/* eslint-disable */
import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | undefined;
export type InputMaybe<T> = T | undefined;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: number;
  DateTime: string;
};

export type Account = {
  readonly __typename?: 'Account';
  readonly access_token?: Maybe<Scalars['String']>;
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly id_token?: Maybe<Scalars['String']>;
  readonly oauth_token?: Maybe<Scalars['String']>;
  readonly oauth_token_secret?: Maybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: Maybe<Scalars['String']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
  readonly scope?: Maybe<Scalars['String']>;
  readonly session_state?: Maybe<Scalars['String']>;
  readonly token_type?: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type AccountAvgAggregate = {
  readonly __typename?: 'AccountAvgAggregate';
  readonly expires_at?: Maybe<Scalars['Float']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Float']>;
};

export type AccountAvgOrderByAggregateInput = {
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
};

export type AccountCountAggregate = {
  readonly __typename?: 'AccountCountAggregate';
  readonly _all: Scalars['Int'];
  readonly access_token: Scalars['Int'];
  readonly expires_at: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly id_token: Scalars['Int'];
  readonly oauth_token: Scalars['Int'];
  readonly oauth_token_secret: Scalars['Int'];
  readonly provider: Scalars['Int'];
  readonly providerAccountId: Scalars['Int'];
  readonly refresh_token: Scalars['Int'];
  readonly refresh_token_expires_in: Scalars['Int'];
  readonly scope: Scalars['Int'];
  readonly session_state: Scalars['Int'];
  readonly token_type: Scalars['Int'];
  readonly type: Scalars['Int'];
  readonly userId: Scalars['Int'];
};

export type AccountCountOrderByAggregateInput = {
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountCreateInput = {
  readonly access_token?: InputMaybe<Scalars['String']>;
  readonly expires_at?: InputMaybe<Scalars['Int']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly id_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token_secret?: InputMaybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: InputMaybe<Scalars['String']>;
  readonly refresh_token_expires_in?: InputMaybe<Scalars['Int']>;
  readonly scope?: InputMaybe<Scalars['String']>;
  readonly session_state?: InputMaybe<Scalars['String']>;
  readonly token_type?: InputMaybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly user: UserCreateNestedOneWithoutAccountsInput;
};

export type AccountCreateManyInput = {
  readonly access_token?: InputMaybe<Scalars['String']>;
  readonly expires_at?: InputMaybe<Scalars['Int']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly id_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token_secret?: InputMaybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: InputMaybe<Scalars['String']>;
  readonly refresh_token_expires_in?: InputMaybe<Scalars['Int']>;
  readonly scope?: InputMaybe<Scalars['String']>;
  readonly session_state?: InputMaybe<Scalars['String']>;
  readonly token_type?: InputMaybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type AccountCreateManyUserInput = {
  readonly access_token?: InputMaybe<Scalars['String']>;
  readonly expires_at?: InputMaybe<Scalars['Int']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly id_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token_secret?: InputMaybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: InputMaybe<Scalars['String']>;
  readonly refresh_token_expires_in?: InputMaybe<Scalars['Int']>;
  readonly scope?: InputMaybe<Scalars['String']>;
  readonly session_state?: InputMaybe<Scalars['String']>;
  readonly token_type?: InputMaybe<Scalars['String']>;
  readonly type: Scalars['String'];
};

export type AccountCreateManyUserInputEnvelope = {
  readonly data: ReadonlyArray<AccountCreateManyUserInput>;
  readonly skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AccountCreateNestedManyWithoutUserInput = {
  readonly connect?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<AccountCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<AccountCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
};

export type AccountCreateOrConnectWithoutUserInput = {
  readonly create: AccountCreateWithoutUserInput;
  readonly where: AccountWhereUniqueInput;
};

export type AccountCreateWithoutUserInput = {
  readonly access_token?: InputMaybe<Scalars['String']>;
  readonly expires_at?: InputMaybe<Scalars['Int']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly id_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token?: InputMaybe<Scalars['String']>;
  readonly oauth_token_secret?: InputMaybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: InputMaybe<Scalars['String']>;
  readonly refresh_token_expires_in?: InputMaybe<Scalars['Int']>;
  readonly scope?: InputMaybe<Scalars['String']>;
  readonly session_state?: InputMaybe<Scalars['String']>;
  readonly token_type?: InputMaybe<Scalars['String']>;
  readonly type: Scalars['String'];
};

export type AccountGroupBy = {
  readonly __typename?: 'AccountGroupBy';
  readonly _avg?: Maybe<AccountAvgAggregate>;
  readonly _count?: Maybe<AccountCountAggregate>;
  readonly _max?: Maybe<AccountMaxAggregate>;
  readonly _min?: Maybe<AccountMinAggregate>;
  readonly _sum?: Maybe<AccountSumAggregate>;
  readonly access_token?: Maybe<Scalars['String']>;
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly id: Scalars['String'];
  readonly id_token?: Maybe<Scalars['String']>;
  readonly oauth_token?: Maybe<Scalars['String']>;
  readonly oauth_token_secret?: Maybe<Scalars['String']>;
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
  readonly refresh_token?: Maybe<Scalars['String']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
  readonly scope?: Maybe<Scalars['String']>;
  readonly session_state?: Maybe<Scalars['String']>;
  readonly token_type?: Maybe<Scalars['String']>;
  readonly type: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type AccountListRelationFilter = {
  readonly every?: InputMaybe<AccountWhereInput>;
  readonly none?: InputMaybe<AccountWhereInput>;
  readonly some?: InputMaybe<AccountWhereInput>;
};

export type AccountMaxAggregate = {
  readonly __typename?: 'AccountMaxAggregate';
  readonly access_token?: Maybe<Scalars['String']>;
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly id_token?: Maybe<Scalars['String']>;
  readonly oauth_token?: Maybe<Scalars['String']>;
  readonly oauth_token_secret?: Maybe<Scalars['String']>;
  readonly provider?: Maybe<Scalars['String']>;
  readonly providerAccountId?: Maybe<Scalars['String']>;
  readonly refresh_token?: Maybe<Scalars['String']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
  readonly scope?: Maybe<Scalars['String']>;
  readonly session_state?: Maybe<Scalars['String']>;
  readonly token_type?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type AccountMaxOrderByAggregateInput = {
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountMinAggregate = {
  readonly __typename?: 'AccountMinAggregate';
  readonly access_token?: Maybe<Scalars['String']>;
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly id_token?: Maybe<Scalars['String']>;
  readonly oauth_token?: Maybe<Scalars['String']>;
  readonly oauth_token_secret?: Maybe<Scalars['String']>;
  readonly provider?: Maybe<Scalars['String']>;
  readonly providerAccountId?: Maybe<Scalars['String']>;
  readonly refresh_token?: Maybe<Scalars['String']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
  readonly scope?: Maybe<Scalars['String']>;
  readonly session_state?: Maybe<Scalars['String']>;
  readonly token_type?: Maybe<Scalars['String']>;
  readonly type?: Maybe<Scalars['String']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type AccountMinOrderByAggregateInput = {
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type AccountOrderByWithAggregationInput = {
  readonly _avg?: InputMaybe<AccountAvgOrderByAggregateInput>;
  readonly _count?: InputMaybe<AccountCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<AccountMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<AccountMinOrderByAggregateInput>;
  readonly _sum?: InputMaybe<AccountSumOrderByAggregateInput>;
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountOrderByWithRelationInput = {
  readonly access_token?: InputMaybe<SortOrder>;
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly id_token?: InputMaybe<SortOrder>;
  readonly oauth_token?: InputMaybe<SortOrder>;
  readonly oauth_token_secret?: InputMaybe<SortOrder>;
  readonly provider?: InputMaybe<SortOrder>;
  readonly providerAccountId?: InputMaybe<SortOrder>;
  readonly refresh_token?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
  readonly scope?: InputMaybe<SortOrder>;
  readonly session_state?: InputMaybe<SortOrder>;
  readonly token_type?: InputMaybe<SortOrder>;
  readonly type?: InputMaybe<SortOrder>;
  readonly user?: InputMaybe<UserOrderByWithRelationInput>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type AccountProviderProviderAccountIdCompoundUniqueInput = {
  readonly provider: Scalars['String'];
  readonly providerAccountId: Scalars['String'];
};

export const AccountScalarFieldEnum = {
  AccessToken: 'access_token',
  ExpiresAt: 'expires_at',
  Id: 'id',
  IdToken: 'id_token',
  OauthToken: 'oauth_token',
  OauthTokenSecret: 'oauth_token_secret',
  Provider: 'provider',
  ProviderAccountId: 'providerAccountId',
  RefreshToken: 'refresh_token',
  RefreshTokenExpiresIn: 'refresh_token_expires_in',
  Scope: 'scope',
  SessionState: 'session_state',
  TokenType: 'token_type',
  Type: 'type',
  UserId: 'userId'
} as const;

export type AccountScalarFieldEnum = typeof AccountScalarFieldEnum[keyof typeof AccountScalarFieldEnum];
export type AccountScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<AccountScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<AccountScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<AccountScalarWhereInput>>;
  readonly access_token?: InputMaybe<StringNullableFilter>;
  readonly expires_at?: InputMaybe<IntNullableFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly id_token?: InputMaybe<StringNullableFilter>;
  readonly oauth_token?: InputMaybe<StringNullableFilter>;
  readonly oauth_token_secret?: InputMaybe<StringNullableFilter>;
  readonly provider?: InputMaybe<StringFilter>;
  readonly providerAccountId?: InputMaybe<StringFilter>;
  readonly refresh_token?: InputMaybe<StringNullableFilter>;
  readonly refresh_token_expires_in?: InputMaybe<IntNullableFilter>;
  readonly scope?: InputMaybe<StringNullableFilter>;
  readonly session_state?: InputMaybe<StringNullableFilter>;
  readonly token_type?: InputMaybe<StringNullableFilter>;
  readonly type?: InputMaybe<StringFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type AccountScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<AccountScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<AccountScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<AccountScalarWhereWithAggregatesInput>>;
  readonly access_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly expires_at?: InputMaybe<IntNullableWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly id_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly oauth_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly oauth_token_secret?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly provider?: InputMaybe<StringWithAggregatesFilter>;
  readonly providerAccountId?: InputMaybe<StringWithAggregatesFilter>;
  readonly refresh_token?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly refresh_token_expires_in?: InputMaybe<IntNullableWithAggregatesFilter>;
  readonly scope?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly session_state?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly token_type?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly type?: InputMaybe<StringWithAggregatesFilter>;
  readonly userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type AccountSumAggregate = {
  readonly __typename?: 'AccountSumAggregate';
  readonly expires_at?: Maybe<Scalars['Int']>;
  readonly refresh_token_expires_in?: Maybe<Scalars['Int']>;
};

export type AccountSumOrderByAggregateInput = {
  readonly expires_at?: InputMaybe<SortOrder>;
  readonly refresh_token_expires_in?: InputMaybe<SortOrder>;
};

export type AccountUpdateInput = {
  readonly access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token_secret?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly refresh_token_expires_in?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly type?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly user?: InputMaybe<UserUpdateOneRequiredWithoutAccountsNestedInput>;
};

export type AccountUpdateManyMutationInput = {
  readonly access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token_secret?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly refresh_token_expires_in?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccountUpdateManyWithWhereWithoutUserInput = {
  readonly data: AccountUpdateManyMutationInput;
  readonly where: AccountScalarWhereInput;
};

export type AccountUpdateManyWithoutUserNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<AccountCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<AccountCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<AccountCreateManyUserInputEnvelope>;
  readonly delete?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<AccountScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<AccountWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<AccountUpdateWithWhereUniqueWithoutUserInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<AccountUpdateManyWithWhereWithoutUserInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<AccountUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AccountUpdateWithWhereUniqueWithoutUserInput = {
  readonly data: AccountUpdateWithoutUserInput;
  readonly where: AccountWhereUniqueInput;
};

export type AccountUpdateWithoutUserInput = {
  readonly access_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly expires_at?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly oauth_token_secret?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly provider?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly providerAccountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly refresh_token?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly refresh_token_expires_in?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly scope?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly session_state?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly token_type?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccountUpsertWithWhereUniqueWithoutUserInput = {
  readonly create: AccountCreateWithoutUserInput;
  readonly update: AccountUpdateWithoutUserInput;
  readonly where: AccountWhereUniqueInput;
};

export type AccountWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<AccountWhereInput>>;
  readonly access_token?: InputMaybe<StringNullableFilter>;
  readonly expires_at?: InputMaybe<IntNullableFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly id_token?: InputMaybe<StringNullableFilter>;
  readonly oauth_token?: InputMaybe<StringNullableFilter>;
  readonly oauth_token_secret?: InputMaybe<StringNullableFilter>;
  readonly provider?: InputMaybe<StringFilter>;
  readonly providerAccountId?: InputMaybe<StringFilter>;
  readonly refresh_token?: InputMaybe<StringNullableFilter>;
  readonly refresh_token_expires_in?: InputMaybe<IntNullableFilter>;
  readonly scope?: InputMaybe<StringNullableFilter>;
  readonly session_state?: InputMaybe<StringNullableFilter>;
  readonly token_type?: InputMaybe<StringNullableFilter>;
  readonly type?: InputMaybe<StringFilter>;
  readonly user?: InputMaybe<UserRelationFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type AccountWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly provider_providerAccountId?: InputMaybe<AccountProviderProviderAccountIdCompoundUniqueInput>;
};

export type AffectedRowsOutput = {
  readonly __typename?: 'AffectedRowsOutput';
  readonly count: Scalars['Int'];
};

export type AggregateAccount = {
  readonly __typename?: 'AggregateAccount';
  readonly _avg?: Maybe<AccountAvgAggregate>;
  readonly _count?: Maybe<AccountCountAggregate>;
  readonly _max?: Maybe<AccountMaxAggregate>;
  readonly _min?: Maybe<AccountMinAggregate>;
  readonly _sum?: Maybe<AccountSumAggregate>;
};

export type AggregateDevAllowedEmail = {
  readonly __typename?: 'AggregateDevAllowedEmail';
  readonly _count?: Maybe<DevAllowedEmailCountAggregate>;
  readonly _max?: Maybe<DevAllowedEmailMaxAggregate>;
  readonly _min?: Maybe<DevAllowedEmailMinAggregate>;
};

export type AggregateGame = {
  readonly __typename?: 'AggregateGame';
  readonly _avg?: Maybe<GameAvgAggregate>;
  readonly _count?: Maybe<GameCountAggregate>;
  readonly _max?: Maybe<GameMaxAggregate>;
  readonly _min?: Maybe<GameMinAggregate>;
  readonly _sum?: Maybe<GameSumAggregate>;
};

export type AggregateGroup = {
  readonly __typename?: 'AggregateGroup';
  readonly _count?: Maybe<GroupCountAggregate>;
  readonly _max?: Maybe<GroupMaxAggregate>;
  readonly _min?: Maybe<GroupMinAggregate>;
};

export type AggregateResult = {
  readonly __typename?: 'AggregateResult';
  readonly _avg?: Maybe<ResultAvgAggregate>;
  readonly _count?: Maybe<ResultCountAggregate>;
  readonly _max?: Maybe<ResultMaxAggregate>;
  readonly _min?: Maybe<ResultMinAggregate>;
  readonly _sum?: Maybe<ResultSumAggregate>;
};

export type AggregateSession = {
  readonly __typename?: 'AggregateSession';
  readonly _count?: Maybe<SessionCountAggregate>;
  readonly _max?: Maybe<SessionMaxAggregate>;
  readonly _min?: Maybe<SessionMinAggregate>;
};

export type AggregateUser = {
  readonly __typename?: 'AggregateUser';
  readonly _count?: Maybe<UserCountAggregate>;
  readonly _max?: Maybe<UserMaxAggregate>;
  readonly _min?: Maybe<UserMinAggregate>;
};

export type AggregateVerificationToken = {
  readonly __typename?: 'AggregateVerificationToken';
  readonly _count?: Maybe<VerificationTokenCountAggregate>;
  readonly _max?: Maybe<VerificationTokenMaxAggregate>;
  readonly _min?: Maybe<VerificationTokenMinAggregate>;
};

export type BigIntFieldUpdateOperationsInput = {
  readonly decrement?: InputMaybe<Scalars['BigInt']>;
  readonly divide?: InputMaybe<Scalars['BigInt']>;
  readonly increment?: InputMaybe<Scalars['BigInt']>;
  readonly multiply?: InputMaybe<Scalars['BigInt']>;
  readonly set?: InputMaybe<Scalars['BigInt']>;
};

export type BigIntFilter = {
  readonly equals?: InputMaybe<Scalars['BigInt']>;
  readonly gt?: InputMaybe<Scalars['BigInt']>;
  readonly gte?: InputMaybe<Scalars['BigInt']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['BigInt']>>;
  readonly lt?: InputMaybe<Scalars['BigInt']>;
  readonly lte?: InputMaybe<Scalars['BigInt']>;
  readonly not?: InputMaybe<NestedBigIntFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['BigInt']>>;
};

export type BigIntWithAggregatesFilter = {
  readonly _avg?: InputMaybe<NestedFloatFilter>;
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedBigIntFilter>;
  readonly _min?: InputMaybe<NestedBigIntFilter>;
  readonly _sum?: InputMaybe<NestedBigIntFilter>;
  readonly equals?: InputMaybe<Scalars['BigInt']>;
  readonly gt?: InputMaybe<Scalars['BigInt']>;
  readonly gte?: InputMaybe<Scalars['BigInt']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['BigInt']>>;
  readonly lt?: InputMaybe<Scalars['BigInt']>;
  readonly lte?: InputMaybe<Scalars['BigInt']>;
  readonly not?: InputMaybe<NestedBigIntWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['BigInt']>>;
};

export type BoolFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  readonly equals?: InputMaybe<Scalars['Boolean']>;
  readonly not?: InputMaybe<NestedBoolFilter>;
};

export type BoolWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedBoolFilter>;
  readonly _min?: InputMaybe<NestedBoolFilter>;
  readonly equals?: InputMaybe<Scalars['Boolean']>;
  readonly not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type DateTimeFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly _min?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedDateTimeFilter>;
  readonly _min?: InputMaybe<NestedDateTimeFilter>;
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type DevAllowedEmail = {
  readonly __typename?: 'DevAllowedEmail';
  readonly email: Scalars['String'];
  readonly id: Scalars['String'];
};

export type DevAllowedEmailCountAggregate = {
  readonly __typename?: 'DevAllowedEmailCountAggregate';
  readonly _all: Scalars['Int'];
  readonly email: Scalars['Int'];
  readonly id: Scalars['Int'];
};

export type DevAllowedEmailCountOrderByAggregateInput = {
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export type DevAllowedEmailCreateInput = {
  readonly email: Scalars['String'];
  readonly id?: InputMaybe<Scalars['String']>;
};

export type DevAllowedEmailCreateManyInput = {
  readonly email: Scalars['String'];
  readonly id?: InputMaybe<Scalars['String']>;
};

export type DevAllowedEmailGroupBy = {
  readonly __typename?: 'DevAllowedEmailGroupBy';
  readonly _count?: Maybe<DevAllowedEmailCountAggregate>;
  readonly _max?: Maybe<DevAllowedEmailMaxAggregate>;
  readonly _min?: Maybe<DevAllowedEmailMinAggregate>;
  readonly email: Scalars['String'];
  readonly id: Scalars['String'];
};

export type DevAllowedEmailMaxAggregate = {
  readonly __typename?: 'DevAllowedEmailMaxAggregate';
  readonly email?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
};

export type DevAllowedEmailMaxOrderByAggregateInput = {
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export type DevAllowedEmailMinAggregate = {
  readonly __typename?: 'DevAllowedEmailMinAggregate';
  readonly email?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
};

export type DevAllowedEmailMinOrderByAggregateInput = {
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export type DevAllowedEmailOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<DevAllowedEmailCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<DevAllowedEmailMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<DevAllowedEmailMinOrderByAggregateInput>;
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export type DevAllowedEmailOrderByWithRelationInput = {
  readonly email?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
};

export const DevAllowedEmailScalarFieldEnum = {
  Email: 'email',
  Id: 'id'
} as const;

export type DevAllowedEmailScalarFieldEnum = typeof DevAllowedEmailScalarFieldEnum[keyof typeof DevAllowedEmailScalarFieldEnum];
export type DevAllowedEmailScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarWhereWithAggregatesInput>>;
  readonly email?: InputMaybe<StringWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
};

export type DevAllowedEmailUpdateInput = {
  readonly email?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DevAllowedEmailUpdateManyMutationInput = {
  readonly email?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type DevAllowedEmailWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<DevAllowedEmailWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<DevAllowedEmailWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<DevAllowedEmailWhereInput>>;
  readonly email?: InputMaybe<StringFilter>;
  readonly id?: InputMaybe<StringFilter>;
};

export type DevAllowedEmailWhereUniqueInput = {
  readonly email?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
};

export type EnumGameTypeFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<GameType>;
};

export type EnumGameTypeFilter = {
  readonly equals?: InputMaybe<GameType>;
  readonly in?: InputMaybe<ReadonlyArray<GameType>>;
  readonly not?: InputMaybe<NestedEnumGameTypeFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<GameType>>;
};

export type EnumGameTypeWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedEnumGameTypeFilter>;
  readonly _min?: InputMaybe<NestedEnumGameTypeFilter>;
  readonly equals?: InputMaybe<GameType>;
  readonly in?: InputMaybe<ReadonlyArray<GameType>>;
  readonly not?: InputMaybe<NestedEnumGameTypeWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<GameType>>;
};

export type Game = {
  readonly __typename?: 'Game';
  readonly _count?: Maybe<GameCount>;
  readonly createdAt: Scalars['DateTime'];
  readonly gameType: GameType;
  readonly id: Scalars['String'];
  readonly results: ReadonlyArray<Result>;
  readonly seed: Scalars['BigInt'];
};


export type GameResultsArgs = {
  cursor?: InputMaybe<ResultWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<ResultScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<ResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResultWhereInput>;
};

export type GameAvgAggregate = {
  readonly __typename?: 'GameAvgAggregate';
  readonly seed?: Maybe<Scalars['Float']>;
};

export type GameAvgOrderByAggregateInput = {
  readonly seed?: InputMaybe<SortOrder>;
};

export type GameCount = {
  readonly __typename?: 'GameCount';
  readonly results: Scalars['Int'];
};

export type GameCountAggregate = {
  readonly __typename?: 'GameCountAggregate';
  readonly _all: Scalars['Int'];
  readonly createdAt: Scalars['Int'];
  readonly gameType: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly seed: Scalars['Int'];
};

export type GameCountOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly seed?: InputMaybe<SortOrder>;
};

export type GameCreateInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly gameType: GameType;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly results?: InputMaybe<ResultCreateNestedManyWithoutGameInput>;
  readonly seed: Scalars['BigInt'];
};

export type GameCreateManyInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly gameType: GameType;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly seed: Scalars['BigInt'];
};

export type GameCreateNestedOneWithoutResultsInput = {
  readonly connect?: InputMaybe<GameWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<GameCreateOrConnectWithoutResultsInput>;
  readonly create?: InputMaybe<GameCreateWithoutResultsInput>;
};

export type GameCreateOrConnectWithoutResultsInput = {
  readonly create: GameCreateWithoutResultsInput;
  readonly where: GameWhereUniqueInput;
};

export type GameCreateWithoutResultsInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly gameType: GameType;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly seed: Scalars['BigInt'];
};

export type GameGroupBy = {
  readonly __typename?: 'GameGroupBy';
  readonly _avg?: Maybe<GameAvgAggregate>;
  readonly _count?: Maybe<GameCountAggregate>;
  readonly _max?: Maybe<GameMaxAggregate>;
  readonly _min?: Maybe<GameMinAggregate>;
  readonly _sum?: Maybe<GameSumAggregate>;
  readonly createdAt: Scalars['DateTime'];
  readonly gameType: GameType;
  readonly id: Scalars['String'];
  readonly seed: Scalars['BigInt'];
};

export type GameMaxAggregate = {
  readonly __typename?: 'GameMaxAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly gameType?: Maybe<GameType>;
  readonly id?: Maybe<Scalars['String']>;
  readonly seed?: Maybe<Scalars['BigInt']>;
};

export type GameMaxOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly seed?: InputMaybe<SortOrder>;
};

export type GameMinAggregate = {
  readonly __typename?: 'GameMinAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly gameType?: Maybe<GameType>;
  readonly id?: Maybe<Scalars['String']>;
  readonly seed?: Maybe<Scalars['BigInt']>;
};

export type GameMinOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly seed?: InputMaybe<SortOrder>;
};

export type GameOrderByWithAggregationInput = {
  readonly _avg?: InputMaybe<GameAvgOrderByAggregateInput>;
  readonly _count?: InputMaybe<GameCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<GameMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<GameMinOrderByAggregateInput>;
  readonly _sum?: InputMaybe<GameSumOrderByAggregateInput>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly seed?: InputMaybe<SortOrder>;
};

export type GameOrderByWithRelationInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly results?: InputMaybe<ResultOrderByRelationAggregateInput>;
  readonly seed?: InputMaybe<SortOrder>;
};

export type GameRelationFilter = {
  readonly is?: InputMaybe<GameWhereInput>;
  readonly isNot?: InputMaybe<GameWhereInput>;
};

export const GameScalarFieldEnum = {
  CreatedAt: 'createdAt',
  GameType: 'gameType',
  Id: 'id',
  Seed: 'seed'
} as const;

export type GameScalarFieldEnum = typeof GameScalarFieldEnum[keyof typeof GameScalarFieldEnum];
export type GameScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<GameScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<GameScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<GameScalarWhereWithAggregatesInput>>;
  readonly createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly gameType?: InputMaybe<EnumGameTypeWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly seed?: InputMaybe<BigIntWithAggregatesFilter>;
};

export type GameSumAggregate = {
  readonly __typename?: 'GameSumAggregate';
  readonly seed?: Maybe<Scalars['BigInt']>;
};

export type GameSumOrderByAggregateInput = {
  readonly seed?: InputMaybe<SortOrder>;
};

export const GameType = {
  WordGolf: 'WORD_GOLF'
} as const;

export type GameType = typeof GameType[keyof typeof GameType];
export type GameUpdateInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly results?: InputMaybe<ResultUpdateManyWithoutGameNestedInput>;
  readonly seed?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type GameUpdateManyMutationInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly seed?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type GameUpdateOneRequiredWithoutResultsNestedInput = {
  readonly connect?: InputMaybe<GameWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<GameCreateOrConnectWithoutResultsInput>;
  readonly create?: InputMaybe<GameCreateWithoutResultsInput>;
  readonly update?: InputMaybe<GameUpdateWithoutResultsInput>;
  readonly upsert?: InputMaybe<GameUpsertWithoutResultsInput>;
};

export type GameUpdateWithoutResultsInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly seed?: InputMaybe<BigIntFieldUpdateOperationsInput>;
};

export type GameUpsertWithoutResultsInput = {
  readonly create: GameCreateWithoutResultsInput;
  readonly update: GameUpdateWithoutResultsInput;
};

export type GameWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<GameWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<GameWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<GameWhereInput>>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly gameType?: InputMaybe<EnumGameTypeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly results?: InputMaybe<ResultListRelationFilter>;
  readonly seed?: InputMaybe<BigIntFilter>;
};

export type GameWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
};

export type Group = {
  readonly __typename?: 'Group';
  readonly _count?: Maybe<GroupCount>;
  readonly createdAt: Scalars['DateTime'];
  readonly endAt: Scalars['DateTime'];
  readonly gameOptions?: Maybe<Scalars['String']>;
  readonly gameType: GameType;
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
  readonly users: ReadonlyArray<User>;
};


export type GroupUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type GroupCount = {
  readonly __typename?: 'GroupCount';
  readonly users: Scalars['Int'];
};

export type GroupCountAggregate = {
  readonly __typename?: 'GroupCountAggregate';
  readonly _all: Scalars['Int'];
  readonly createdAt: Scalars['Int'];
  readonly endAt: Scalars['Int'];
  readonly gameOptions: Scalars['Int'];
  readonly gameType: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly name: Scalars['Int'];
  readonly updatedAt: Scalars['Int'];
};

export type GroupCountOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly endAt?: InputMaybe<SortOrder>;
  readonly gameOptions?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type GroupCreateInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly endAt: Scalars['DateTime'];
  readonly gameOptions?: InputMaybe<Scalars['String']>;
  readonly gameType: GameType;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly users?: InputMaybe<UserCreateNestedManyWithoutGroupsInput>;
};

export type GroupCreateManyInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly endAt: Scalars['DateTime'];
  readonly gameOptions?: InputMaybe<Scalars['String']>;
  readonly gameType: GameType;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type GroupCreateNestedManyWithoutUsersInput = {
  readonly connect?: InputMaybe<ReadonlyArray<GroupWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<GroupCreateOrConnectWithoutUsersInput>>;
  readonly create?: InputMaybe<ReadonlyArray<GroupCreateWithoutUsersInput>>;
};

export type GroupCreateOrConnectWithoutUsersInput = {
  readonly create: GroupCreateWithoutUsersInput;
  readonly where: GroupWhereUniqueInput;
};

export type GroupCreateWithoutUsersInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly endAt: Scalars['DateTime'];
  readonly gameOptions?: InputMaybe<Scalars['String']>;
  readonly gameType: GameType;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly name: Scalars['String'];
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type GroupGroupBy = {
  readonly __typename?: 'GroupGroupBy';
  readonly _count?: Maybe<GroupCountAggregate>;
  readonly _max?: Maybe<GroupMaxAggregate>;
  readonly _min?: Maybe<GroupMinAggregate>;
  readonly createdAt: Scalars['DateTime'];
  readonly endAt: Scalars['DateTime'];
  readonly gameOptions?: Maybe<Scalars['String']>;
  readonly gameType: GameType;
  readonly id: Scalars['String'];
  readonly name: Scalars['String'];
  readonly updatedAt: Scalars['DateTime'];
};

export type GroupListRelationFilter = {
  readonly every?: InputMaybe<GroupWhereInput>;
  readonly none?: InputMaybe<GroupWhereInput>;
  readonly some?: InputMaybe<GroupWhereInput>;
};

export type GroupMaxAggregate = {
  readonly __typename?: 'GroupMaxAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly endAt?: Maybe<Scalars['DateTime']>;
  readonly gameOptions?: Maybe<Scalars['String']>;
  readonly gameType?: Maybe<GameType>;
  readonly id?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupMaxOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly endAt?: InputMaybe<SortOrder>;
  readonly gameOptions?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type GroupMinAggregate = {
  readonly __typename?: 'GroupMinAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly endAt?: Maybe<Scalars['DateTime']>;
  readonly gameOptions?: Maybe<Scalars['String']>;
  readonly gameType?: Maybe<GameType>;
  readonly id?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
};

export type GroupMinOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly endAt?: InputMaybe<SortOrder>;
  readonly gameOptions?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type GroupOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type GroupOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<GroupCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<GroupMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<GroupMinOrderByAggregateInput>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly endAt?: InputMaybe<SortOrder>;
  readonly gameOptions?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
};

export type GroupOrderByWithRelationInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly endAt?: InputMaybe<SortOrder>;
  readonly gameOptions?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export const GroupScalarFieldEnum = {
  CreatedAt: 'createdAt',
  EndAt: 'endAt',
  GameOptions: 'gameOptions',
  GameType: 'gameType',
  Id: 'id',
  Name: 'name',
  UpdatedAt: 'updatedAt'
} as const;

export type GroupScalarFieldEnum = typeof GroupScalarFieldEnum[keyof typeof GroupScalarFieldEnum];
export type GroupScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<GroupScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<GroupScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<GroupScalarWhereInput>>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly endAt?: InputMaybe<DateTimeFilter>;
  readonly gameOptions?: InputMaybe<StringNullableFilter>;
  readonly gameType?: InputMaybe<EnumGameTypeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly name?: InputMaybe<StringFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
};

export type GroupScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<GroupScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<GroupScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<GroupScalarWhereWithAggregatesInput>>;
  readonly createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly endAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly gameOptions?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly gameType?: InputMaybe<EnumGameTypeWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly name?: InputMaybe<StringWithAggregatesFilter>;
  readonly updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type GroupUpdateInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly endAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly gameOptions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly users?: InputMaybe<UserUpdateManyWithoutGroupsNestedInput>;
};

export type GroupUpdateManyMutationInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly endAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly gameOptions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpdateManyWithWhereWithoutUsersInput = {
  readonly data: GroupUpdateManyMutationInput;
  readonly where: GroupScalarWhereInput;
};

export type GroupUpdateManyWithoutUsersNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<GroupWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<GroupCreateOrConnectWithoutUsersInput>>;
  readonly create?: InputMaybe<ReadonlyArray<GroupCreateWithoutUsersInput>>;
  readonly delete?: InputMaybe<ReadonlyArray<GroupWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<GroupScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<GroupWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<GroupWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<GroupUpdateWithWhereUniqueWithoutUsersInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<GroupUpdateManyWithWhereWithoutUsersInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<GroupUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type GroupUpdateWithWhereUniqueWithoutUsersInput = {
  readonly data: GroupUpdateWithoutUsersInput;
  readonly where: GroupWhereUniqueInput;
};

export type GroupUpdateWithoutUsersInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly endAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly gameOptions?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type GroupUpsertWithWhereUniqueWithoutUsersInput = {
  readonly create: GroupCreateWithoutUsersInput;
  readonly update: GroupUpdateWithoutUsersInput;
  readonly where: GroupWhereUniqueInput;
};

export type GroupWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<GroupWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<GroupWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<GroupWhereInput>>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly endAt?: InputMaybe<DateTimeFilter>;
  readonly gameOptions?: InputMaybe<StringNullableFilter>;
  readonly gameType?: InputMaybe<EnumGameTypeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly name?: InputMaybe<StringFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
  readonly users?: InputMaybe<UserListRelationFilter>;
};

export type GroupWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
};

export type IntNullableFilter = {
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type IntNullableWithAggregatesFilter = {
  readonly _avg?: InputMaybe<NestedFloatNullableFilter>;
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedIntNullableFilter>;
  readonly _min?: InputMaybe<NestedIntNullableFilter>;
  readonly _sum?: InputMaybe<NestedIntNullableFilter>;
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type Mutation = {
  readonly __typename?: 'Mutation';
  readonly addFriend: User;
  readonly createManyAccount: AffectedRowsOutput;
  readonly createManyDevAllowedEmail: AffectedRowsOutput;
  readonly createManyGame: AffectedRowsOutput;
  readonly createManyGroup: AffectedRowsOutput;
  readonly createManyResult: AffectedRowsOutput;
  readonly createManySession: AffectedRowsOutput;
  readonly createManyUser: AffectedRowsOutput;
  readonly createManyVerificationToken: AffectedRowsOutput;
  readonly createOneAccount: Account;
  readonly createOneDevAllowedEmail: DevAllowedEmail;
  readonly createOneGame: Game;
  readonly createOneGroup: Group;
  readonly createOneResult: Result;
  readonly createOneSession: Session;
  readonly createOneUser: User;
  readonly createOneVerificationToken: VerificationToken;
  readonly deleteManyAccount: AffectedRowsOutput;
  readonly deleteManyDevAllowedEmail: AffectedRowsOutput;
  readonly deleteManyGame: AffectedRowsOutput;
  readonly deleteManyGroup: AffectedRowsOutput;
  readonly deleteManyResult: AffectedRowsOutput;
  readonly deleteManySession: AffectedRowsOutput;
  readonly deleteManyUser: AffectedRowsOutput;
  readonly deleteManyVerificationToken: AffectedRowsOutput;
  readonly deleteOneAccount?: Maybe<Account>;
  readonly deleteOneDevAllowedEmail?: Maybe<DevAllowedEmail>;
  readonly deleteOneGame?: Maybe<Game>;
  readonly deleteOneGroup?: Maybe<Group>;
  readonly deleteOneResult?: Maybe<Result>;
  readonly deleteOneSession?: Maybe<Session>;
  readonly deleteOneUser?: Maybe<User>;
  readonly deleteOneVerificationToken?: Maybe<VerificationToken>;
  readonly updateManyAccount: AffectedRowsOutput;
  readonly updateManyDevAllowedEmail: AffectedRowsOutput;
  readonly updateManyGame: AffectedRowsOutput;
  readonly updateManyGroup: AffectedRowsOutput;
  readonly updateManyResult: AffectedRowsOutput;
  readonly updateManySession: AffectedRowsOutput;
  readonly updateManyUser: AffectedRowsOutput;
  readonly updateManyVerificationToken: AffectedRowsOutput;
  readonly updateOneAccount?: Maybe<Account>;
  readonly updateOneDevAllowedEmail?: Maybe<DevAllowedEmail>;
  readonly updateOneGame?: Maybe<Game>;
  readonly updateOneGroup?: Maybe<Group>;
  readonly updateOneResult?: Maybe<Result>;
  readonly updateOneSession?: Maybe<Session>;
  readonly updateOneUser?: Maybe<User>;
  readonly updateOneVerificationToken?: Maybe<VerificationToken>;
  readonly upsertOneAccount: Account;
  readonly upsertOneDevAllowedEmail: DevAllowedEmail;
  readonly upsertOneGame: Game;
  readonly upsertOneGroup: Group;
  readonly upsertOneResult: Result;
  readonly upsertOneSession: Session;
  readonly upsertOneUser: User;
  readonly upsertOneVerificationToken: VerificationToken;
};


export type MutationAddFriendArgs = {
  friendId: Scalars['String'];
  where: UserWhereUniqueInput;
};


export type MutationCreateManyAccountArgs = {
  data: ReadonlyArray<AccountCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyDevAllowedEmailArgs = {
  data: ReadonlyArray<DevAllowedEmailCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyGameArgs = {
  data: ReadonlyArray<GameCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyGroupArgs = {
  data: ReadonlyArray<GroupCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyResultArgs = {
  data: ReadonlyArray<ResultCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManySessionArgs = {
  data: ReadonlyArray<SessionCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyUserArgs = {
  data: ReadonlyArray<UserCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyVerificationTokenArgs = {
  data: ReadonlyArray<VerificationTokenCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateOneAccountArgs = {
  data: AccountCreateInput;
};


export type MutationCreateOneDevAllowedEmailArgs = {
  data: DevAllowedEmailCreateInput;
};


export type MutationCreateOneGameArgs = {
  data: GameCreateInput;
};


export type MutationCreateOneGroupArgs = {
  data: GroupCreateInput;
};


export type MutationCreateOneResultArgs = {
  data: ResultCreateInput;
};


export type MutationCreateOneSessionArgs = {
  data: SessionCreateInput;
};


export type MutationCreateOneUserArgs = {
  data: UserCreateInput;
};


export type MutationCreateOneVerificationTokenArgs = {
  data: VerificationTokenCreateInput;
};


export type MutationDeleteManyAccountArgs = {
  where?: InputMaybe<AccountWhereInput>;
};


export type MutationDeleteManyDevAllowedEmailArgs = {
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type MutationDeleteManyGameArgs = {
  where?: InputMaybe<GameWhereInput>;
};


export type MutationDeleteManyGroupArgs = {
  where?: InputMaybe<GroupWhereInput>;
};


export type MutationDeleteManyResultArgs = {
  where?: InputMaybe<ResultWhereInput>;
};


export type MutationDeleteManySessionArgs = {
  where?: InputMaybe<SessionWhereInput>;
};


export type MutationDeleteManyUserArgs = {
  where?: InputMaybe<UserWhereInput>;
};


export type MutationDeleteManyVerificationTokenArgs = {
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type MutationDeleteOneAccountArgs = {
  where: AccountWhereUniqueInput;
};


export type MutationDeleteOneDevAllowedEmailArgs = {
  where: DevAllowedEmailWhereUniqueInput;
};


export type MutationDeleteOneGameArgs = {
  where: GameWhereUniqueInput;
};


export type MutationDeleteOneGroupArgs = {
  where: GroupWhereUniqueInput;
};


export type MutationDeleteOneResultArgs = {
  where: ResultWhereUniqueInput;
};


export type MutationDeleteOneSessionArgs = {
  where: SessionWhereUniqueInput;
};


export type MutationDeleteOneUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationDeleteOneVerificationTokenArgs = {
  where: VerificationTokenWhereUniqueInput;
};


export type MutationUpdateManyAccountArgs = {
  data: AccountUpdateManyMutationInput;
  where?: InputMaybe<AccountWhereInput>;
};


export type MutationUpdateManyDevAllowedEmailArgs = {
  data: DevAllowedEmailUpdateManyMutationInput;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type MutationUpdateManyGameArgs = {
  data: GameUpdateManyMutationInput;
  where?: InputMaybe<GameWhereInput>;
};


export type MutationUpdateManyGroupArgs = {
  data: GroupUpdateManyMutationInput;
  where?: InputMaybe<GroupWhereInput>;
};


export type MutationUpdateManyResultArgs = {
  data: ResultUpdateManyMutationInput;
  where?: InputMaybe<ResultWhereInput>;
};


export type MutationUpdateManySessionArgs = {
  data: SessionUpdateManyMutationInput;
  where?: InputMaybe<SessionWhereInput>;
};


export type MutationUpdateManyUserArgs = {
  data: UserUpdateManyMutationInput;
  where?: InputMaybe<UserWhereInput>;
};


export type MutationUpdateManyVerificationTokenArgs = {
  data: VerificationTokenUpdateManyMutationInput;
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type MutationUpdateOneAccountArgs = {
  data: AccountUpdateInput;
  where: AccountWhereUniqueInput;
};


export type MutationUpdateOneDevAllowedEmailArgs = {
  data: DevAllowedEmailUpdateInput;
  where: DevAllowedEmailWhereUniqueInput;
};


export type MutationUpdateOneGameArgs = {
  data: GameUpdateInput;
  where: GameWhereUniqueInput;
};


export type MutationUpdateOneGroupArgs = {
  data: GroupUpdateInput;
  where: GroupWhereUniqueInput;
};


export type MutationUpdateOneResultArgs = {
  data: ResultUpdateInput;
  where: ResultWhereUniqueInput;
};


export type MutationUpdateOneSessionArgs = {
  data: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};


export type MutationUpdateOneUserArgs = {
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateOneVerificationTokenArgs = {
  data: VerificationTokenUpdateInput;
  where: VerificationTokenWhereUniqueInput;
};


export type MutationUpsertOneAccountArgs = {
  create: AccountCreateInput;
  update: AccountUpdateInput;
  where: AccountWhereUniqueInput;
};


export type MutationUpsertOneDevAllowedEmailArgs = {
  create: DevAllowedEmailCreateInput;
  update: DevAllowedEmailUpdateInput;
  where: DevAllowedEmailWhereUniqueInput;
};


export type MutationUpsertOneGameArgs = {
  create: GameCreateInput;
  update: GameUpdateInput;
  where: GameWhereUniqueInput;
};


export type MutationUpsertOneGroupArgs = {
  create: GroupCreateInput;
  update: GroupUpdateInput;
  where: GroupWhereUniqueInput;
};


export type MutationUpsertOneResultArgs = {
  create: ResultCreateInput;
  update: ResultUpdateInput;
  where: ResultWhereUniqueInput;
};


export type MutationUpsertOneSessionArgs = {
  create: SessionCreateInput;
  update: SessionUpdateInput;
  where: SessionWhereUniqueInput;
};


export type MutationUpsertOneUserArgs = {
  create: UserCreateInput;
  update: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpsertOneVerificationTokenArgs = {
  create: VerificationTokenCreateInput;
  update: VerificationTokenUpdateInput;
  where: VerificationTokenWhereUniqueInput;
};

export type NestedBigIntFilter = {
  readonly equals?: InputMaybe<Scalars['BigInt']>;
  readonly gt?: InputMaybe<Scalars['BigInt']>;
  readonly gte?: InputMaybe<Scalars['BigInt']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['BigInt']>>;
  readonly lt?: InputMaybe<Scalars['BigInt']>;
  readonly lte?: InputMaybe<Scalars['BigInt']>;
  readonly not?: InputMaybe<NestedBigIntFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['BigInt']>>;
};

export type NestedBigIntWithAggregatesFilter = {
  readonly _avg?: InputMaybe<NestedFloatFilter>;
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedBigIntFilter>;
  readonly _min?: InputMaybe<NestedBigIntFilter>;
  readonly _sum?: InputMaybe<NestedBigIntFilter>;
  readonly equals?: InputMaybe<Scalars['BigInt']>;
  readonly gt?: InputMaybe<Scalars['BigInt']>;
  readonly gte?: InputMaybe<Scalars['BigInt']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['BigInt']>>;
  readonly lt?: InputMaybe<Scalars['BigInt']>;
  readonly lte?: InputMaybe<Scalars['BigInt']>;
  readonly not?: InputMaybe<NestedBigIntWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['BigInt']>>;
};

export type NestedBoolFilter = {
  readonly equals?: InputMaybe<Scalars['Boolean']>;
  readonly not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedBoolFilter>;
  readonly _min?: InputMaybe<NestedBoolFilter>;
  readonly equals?: InputMaybe<Scalars['Boolean']>;
  readonly not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly _min?: InputMaybe<NestedDateTimeNullableFilter>;
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedDateTimeFilter>;
  readonly _min?: InputMaybe<NestedDateTimeFilter>;
  readonly equals?: InputMaybe<Scalars['DateTime']>;
  readonly gt?: InputMaybe<Scalars['DateTime']>;
  readonly gte?: InputMaybe<Scalars['DateTime']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
  readonly lt?: InputMaybe<Scalars['DateTime']>;
  readonly lte?: InputMaybe<Scalars['DateTime']>;
  readonly not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['DateTime']>>;
};

export type NestedEnumGameTypeFilter = {
  readonly equals?: InputMaybe<GameType>;
  readonly in?: InputMaybe<ReadonlyArray<GameType>>;
  readonly not?: InputMaybe<NestedEnumGameTypeFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<GameType>>;
};

export type NestedEnumGameTypeWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedEnumGameTypeFilter>;
  readonly _min?: InputMaybe<NestedEnumGameTypeFilter>;
  readonly equals?: InputMaybe<GameType>;
  readonly in?: InputMaybe<ReadonlyArray<GameType>>;
  readonly not?: InputMaybe<NestedEnumGameTypeWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<GameType>>;
};

export type NestedFloatFilter = {
  readonly equals?: InputMaybe<Scalars['Float']>;
  readonly gt?: InputMaybe<Scalars['Float']>;
  readonly gte?: InputMaybe<Scalars['Float']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Float']>>;
  readonly lt?: InputMaybe<Scalars['Float']>;
  readonly lte?: InputMaybe<Scalars['Float']>;
  readonly not?: InputMaybe<NestedFloatFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  readonly equals?: InputMaybe<Scalars['Float']>;
  readonly gt?: InputMaybe<Scalars['Float']>;
  readonly gte?: InputMaybe<Scalars['Float']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Float']>>;
  readonly lt?: InputMaybe<Scalars['Float']>;
  readonly lte?: InputMaybe<Scalars['Float']>;
  readonly not?: InputMaybe<NestedFloatNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Float']>>;
};

export type NestedIntFilter = {
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  readonly _avg?: InputMaybe<NestedFloatNullableFilter>;
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedIntNullableFilter>;
  readonly _min?: InputMaybe<NestedIntNullableFilter>;
  readonly _sum?: InputMaybe<NestedIntNullableFilter>;
  readonly equals?: InputMaybe<Scalars['Int']>;
  readonly gt?: InputMaybe<Scalars['Int']>;
  readonly gte?: InputMaybe<Scalars['Int']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
  readonly lt?: InputMaybe<Scalars['Int']>;
  readonly lte?: InputMaybe<Scalars['Int']>;
  readonly not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['Int']>>;
};

export type NestedStringFilter = {
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly not?: InputMaybe<NestedStringFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly not?: InputMaybe<NestedStringNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedStringNullableFilter>;
  readonly _min?: InputMaybe<NestedStringNullableFilter>;
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedStringFilter>;
  readonly _min?: InputMaybe<NestedStringFilter>;
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly not?: InputMaybe<NestedStringWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['DateTime']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  readonly decrement?: InputMaybe<Scalars['Int']>;
  readonly divide?: InputMaybe<Scalars['Int']>;
  readonly increment?: InputMaybe<Scalars['Int']>;
  readonly multiply?: InputMaybe<Scalars['Int']>;
  readonly set?: InputMaybe<Scalars['Int']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['String']>;
};

export type Query = {
  readonly __typename?: 'Query';
  readonly account?: Maybe<Account>;
  readonly accounts: ReadonlyArray<Account>;
  readonly aggregateAccount: AggregateAccount;
  readonly aggregateDevAllowedEmail: AggregateDevAllowedEmail;
  readonly aggregateGame: AggregateGame;
  readonly aggregateGroup: AggregateGroup;
  readonly aggregateResult: AggregateResult;
  readonly aggregateSession: AggregateSession;
  readonly aggregateUser: AggregateUser;
  readonly aggregateVerificationToken: AggregateVerificationToken;
  readonly devAllowedEmail?: Maybe<DevAllowedEmail>;
  readonly devAllowedEmails: ReadonlyArray<DevAllowedEmail>;
  readonly findFirstAccount?: Maybe<Account>;
  readonly findFirstDevAllowedEmail?: Maybe<DevAllowedEmail>;
  readonly findFirstGame?: Maybe<Game>;
  readonly findFirstGroup?: Maybe<Group>;
  readonly findFirstResult?: Maybe<Result>;
  readonly findFirstSession?: Maybe<Session>;
  readonly findFirstUser?: Maybe<User>;
  readonly findFirstVerificationToken?: Maybe<VerificationToken>;
  readonly game?: Maybe<Game>;
  readonly games: ReadonlyArray<Game>;
  readonly getResultForGameType?: Maybe<Result>;
  readonly getSignedInUser?: Maybe<User>;
  readonly group?: Maybe<Group>;
  readonly groupByAccount: ReadonlyArray<AccountGroupBy>;
  readonly groupByDevAllowedEmail: ReadonlyArray<DevAllowedEmailGroupBy>;
  readonly groupByGame: ReadonlyArray<GameGroupBy>;
  readonly groupByGroup: ReadonlyArray<GroupGroupBy>;
  readonly groupByResult: ReadonlyArray<ResultGroupBy>;
  readonly groupBySession: ReadonlyArray<SessionGroupBy>;
  readonly groupByUser: ReadonlyArray<UserGroupBy>;
  readonly groupByVerificationToken: ReadonlyArray<VerificationTokenGroupBy>;
  readonly groups: ReadonlyArray<Group>;
  readonly result?: Maybe<Result>;
  readonly results: ReadonlyArray<Result>;
  readonly session?: Maybe<Session>;
  readonly sessions: ReadonlyArray<Session>;
  readonly user?: Maybe<User>;
  readonly users: ReadonlyArray<User>;
  readonly verificationToken?: Maybe<VerificationToken>;
  readonly verificationTokens: ReadonlyArray<VerificationToken>;
};


export type QueryAccountArgs = {
  where: AccountWhereUniqueInput;
};


export type QueryAccountsArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<AccountScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryAggregateAccountArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryAggregateDevAllowedEmailArgs = {
  cursor?: InputMaybe<DevAllowedEmailWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<DevAllowedEmailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type QueryAggregateGameArgs = {
  cursor?: InputMaybe<GameWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<GameOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameWhereInput>;
};


export type QueryAggregateGroupArgs = {
  cursor?: InputMaybe<GroupWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<GroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GroupWhereInput>;
};


export type QueryAggregateResultArgs = {
  cursor?: InputMaybe<ResultWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<ResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResultWhereInput>;
};


export type QueryAggregateSessionArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type QueryAggregateUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryAggregateVerificationTokenArgs = {
  cursor?: InputMaybe<VerificationTokenWhereUniqueInput>;
  orderBy?: InputMaybe<ReadonlyArray<VerificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type QueryDevAllowedEmailArgs = {
  where: DevAllowedEmailWhereUniqueInput;
};


export type QueryDevAllowedEmailsArgs = {
  cursor?: InputMaybe<DevAllowedEmailWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<DevAllowedEmailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type QueryFindFirstAccountArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<AccountScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryFindFirstDevAllowedEmailArgs = {
  cursor?: InputMaybe<DevAllowedEmailWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<DevAllowedEmailScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<DevAllowedEmailOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type QueryFindFirstGameArgs = {
  cursor?: InputMaybe<GameWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<GameScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<GameOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameWhereInput>;
};


export type QueryFindFirstGroupArgs = {
  cursor?: InputMaybe<GroupWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<GroupScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<GroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GroupWhereInput>;
};


export type QueryFindFirstResultArgs = {
  cursor?: InputMaybe<ResultWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<ResultScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<ResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResultWhereInput>;
};


export type QueryFindFirstSessionArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<SessionScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type QueryFindFirstUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryFindFirstVerificationTokenArgs = {
  cursor?: InputMaybe<VerificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<VerificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<VerificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type QueryGameArgs = {
  where: GameWhereUniqueInput;
};


export type QueryGamesArgs = {
  cursor?: InputMaybe<GameWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<GameScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<GameOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameWhereInput>;
};


export type QueryGetResultForGameTypeArgs = {
  email: Scalars['String'];
  gameType: GameType;
};


export type QueryGroupArgs = {
  where: GroupWhereUniqueInput;
};


export type QueryGroupByAccountArgs = {
  by: ReadonlyArray<AccountScalarFieldEnum>;
  having?: InputMaybe<AccountScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type QueryGroupByDevAllowedEmailArgs = {
  by: ReadonlyArray<DevAllowedEmailScalarFieldEnum>;
  having?: InputMaybe<DevAllowedEmailScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<DevAllowedEmailOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DevAllowedEmailWhereInput>;
};


export type QueryGroupByGameArgs = {
  by: ReadonlyArray<GameScalarFieldEnum>;
  having?: InputMaybe<GameScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<GameOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GameWhereInput>;
};


export type QueryGroupByGroupArgs = {
  by: ReadonlyArray<GroupScalarFieldEnum>;
  having?: InputMaybe<GroupScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<GroupOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GroupWhereInput>;
};


export type QueryGroupByResultArgs = {
  by: ReadonlyArray<ResultScalarFieldEnum>;
  having?: InputMaybe<ResultScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<ResultOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResultWhereInput>;
};


export type QueryGroupBySessionArgs = {
  by: ReadonlyArray<SessionScalarFieldEnum>;
  having?: InputMaybe<SessionScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type QueryGroupByUserArgs = {
  by: ReadonlyArray<UserScalarFieldEnum>;
  having?: InputMaybe<UserScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryGroupByVerificationTokenArgs = {
  by: ReadonlyArray<VerificationTokenScalarFieldEnum>;
  having?: InputMaybe<VerificationTokenScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<ReadonlyArray<VerificationTokenOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VerificationTokenWhereInput>;
};


export type QueryGroupsArgs = {
  cursor?: InputMaybe<GroupWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<GroupScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<GroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GroupWhereInput>;
};


export type QueryResultArgs = {
  where: ResultWhereUniqueInput;
};


export type QueryResultsArgs = {
  cursor?: InputMaybe<ResultWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<ResultScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<ResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResultWhereInput>;
};


export type QuerySessionArgs = {
  where: SessionWhereUniqueInput;
};


export type QuerySessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<SessionScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};


export type QueryUserArgs = {
  where: UserWhereUniqueInput;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryVerificationTokenArgs = {
  where: VerificationTokenWhereUniqueInput;
};


export type QueryVerificationTokensArgs = {
  cursor?: InputMaybe<VerificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<VerificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<VerificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VerificationTokenWhereInput>;
};

export const QueryMode = {
  Default: 'default',
  Insensitive: 'insensitive'
} as const;

export type QueryMode = typeof QueryMode[keyof typeof QueryMode];
export type Result = {
  readonly __typename?: 'Result';
  readonly createdAt: Scalars['DateTime'];
  readonly game: Game;
  readonly gameId: Scalars['String'];
  readonly gameType: GameType;
  readonly history?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly isFinished: Scalars['Boolean'];
  readonly score?: Maybe<Scalars['Int']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type ResultAvgAggregate = {
  readonly __typename?: 'ResultAvgAggregate';
  readonly score?: Maybe<Scalars['Float']>;
};

export type ResultAvgOrderByAggregateInput = {
  readonly score?: InputMaybe<SortOrder>;
};

export type ResultCountAggregate = {
  readonly __typename?: 'ResultCountAggregate';
  readonly _all: Scalars['Int'];
  readonly createdAt: Scalars['Int'];
  readonly gameId: Scalars['Int'];
  readonly gameType: Scalars['Int'];
  readonly history: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly isFinished: Scalars['Int'];
  readonly score: Scalars['Int'];
  readonly updatedAt: Scalars['Int'];
  readonly userId: Scalars['Int'];
};

export type ResultCountOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly gameId?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly history?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly isFinished?: InputMaybe<SortOrder>;
  readonly score?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type ResultCreateInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly game: GameCreateNestedOneWithoutResultsInput;
  readonly gameType: GameType;
  readonly history?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly isFinished?: InputMaybe<Scalars['Boolean']>;
  readonly score?: InputMaybe<Scalars['Int']>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly user: UserCreateNestedOneWithoutResultsInput;
};

export type ResultCreateManyGameInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly gameType: GameType;
  readonly history?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly isFinished?: InputMaybe<Scalars['Boolean']>;
  readonly score?: InputMaybe<Scalars['Int']>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly userId: Scalars['String'];
};

export type ResultCreateManyGameInputEnvelope = {
  readonly data: ReadonlyArray<ResultCreateManyGameInput>;
  readonly skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ResultCreateManyInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly gameId: Scalars['String'];
  readonly gameType: GameType;
  readonly history?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly isFinished?: InputMaybe<Scalars['Boolean']>;
  readonly score?: InputMaybe<Scalars['Int']>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly userId: Scalars['String'];
};

export type ResultCreateManyUserInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly gameId: Scalars['String'];
  readonly gameType: GameType;
  readonly history?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly isFinished?: InputMaybe<Scalars['Boolean']>;
  readonly score?: InputMaybe<Scalars['Int']>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResultCreateManyUserInputEnvelope = {
  readonly data: ReadonlyArray<ResultCreateManyUserInput>;
  readonly skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ResultCreateNestedManyWithoutGameInput = {
  readonly connect?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<ResultCreateOrConnectWithoutGameInput>>;
  readonly create?: InputMaybe<ReadonlyArray<ResultCreateWithoutGameInput>>;
  readonly createMany?: InputMaybe<ResultCreateManyGameInputEnvelope>;
};

export type ResultCreateNestedManyWithoutUserInput = {
  readonly connect?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<ResultCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<ResultCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<ResultCreateManyUserInputEnvelope>;
};

export type ResultCreateOrConnectWithoutGameInput = {
  readonly create: ResultCreateWithoutGameInput;
  readonly where: ResultWhereUniqueInput;
};

export type ResultCreateOrConnectWithoutUserInput = {
  readonly create: ResultCreateWithoutUserInput;
  readonly where: ResultWhereUniqueInput;
};

export type ResultCreateWithoutGameInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly gameType: GameType;
  readonly history?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly isFinished?: InputMaybe<Scalars['Boolean']>;
  readonly score?: InputMaybe<Scalars['Int']>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
  readonly user: UserCreateNestedOneWithoutResultsInput;
};

export type ResultCreateWithoutUserInput = {
  readonly createdAt?: InputMaybe<Scalars['DateTime']>;
  readonly game: GameCreateNestedOneWithoutResultsInput;
  readonly gameType: GameType;
  readonly history?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly isFinished?: InputMaybe<Scalars['Boolean']>;
  readonly score?: InputMaybe<Scalars['Int']>;
  readonly updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResultGroupBy = {
  readonly __typename?: 'ResultGroupBy';
  readonly _avg?: Maybe<ResultAvgAggregate>;
  readonly _count?: Maybe<ResultCountAggregate>;
  readonly _max?: Maybe<ResultMaxAggregate>;
  readonly _min?: Maybe<ResultMinAggregate>;
  readonly _sum?: Maybe<ResultSumAggregate>;
  readonly createdAt: Scalars['DateTime'];
  readonly gameId: Scalars['String'];
  readonly gameType: GameType;
  readonly history?: Maybe<Scalars['String']>;
  readonly id: Scalars['String'];
  readonly isFinished: Scalars['Boolean'];
  readonly score?: Maybe<Scalars['Int']>;
  readonly updatedAt: Scalars['DateTime'];
  readonly userId: Scalars['String'];
};

export type ResultListRelationFilter = {
  readonly every?: InputMaybe<ResultWhereInput>;
  readonly none?: InputMaybe<ResultWhereInput>;
  readonly some?: InputMaybe<ResultWhereInput>;
};

export type ResultMaxAggregate = {
  readonly __typename?: 'ResultMaxAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly gameId?: Maybe<Scalars['String']>;
  readonly gameType?: Maybe<GameType>;
  readonly history?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly isFinished?: Maybe<Scalars['Boolean']>;
  readonly score?: Maybe<Scalars['Int']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type ResultMaxOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly gameId?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly history?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly isFinished?: InputMaybe<SortOrder>;
  readonly score?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type ResultMinAggregate = {
  readonly __typename?: 'ResultMinAggregate';
  readonly createdAt?: Maybe<Scalars['DateTime']>;
  readonly gameId?: Maybe<Scalars['String']>;
  readonly gameType?: Maybe<GameType>;
  readonly history?: Maybe<Scalars['String']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly isFinished?: Maybe<Scalars['Boolean']>;
  readonly score?: Maybe<Scalars['Int']>;
  readonly updatedAt?: Maybe<Scalars['DateTime']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type ResultMinOrderByAggregateInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly gameId?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly history?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly isFinished?: InputMaybe<SortOrder>;
  readonly score?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type ResultOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type ResultOrderByWithAggregationInput = {
  readonly _avg?: InputMaybe<ResultAvgOrderByAggregateInput>;
  readonly _count?: InputMaybe<ResultCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<ResultMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<ResultMinOrderByAggregateInput>;
  readonly _sum?: InputMaybe<ResultSumOrderByAggregateInput>;
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly gameId?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly history?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly isFinished?: InputMaybe<SortOrder>;
  readonly score?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type ResultOrderByWithRelationInput = {
  readonly createdAt?: InputMaybe<SortOrder>;
  readonly game?: InputMaybe<GameOrderByWithRelationInput>;
  readonly gameId?: InputMaybe<SortOrder>;
  readonly gameType?: InputMaybe<SortOrder>;
  readonly history?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly isFinished?: InputMaybe<SortOrder>;
  readonly score?: InputMaybe<SortOrder>;
  readonly updatedAt?: InputMaybe<SortOrder>;
  readonly user?: InputMaybe<UserOrderByWithRelationInput>;
  readonly userId?: InputMaybe<SortOrder>;
};

export const ResultScalarFieldEnum = {
  CreatedAt: 'createdAt',
  GameId: 'gameId',
  GameType: 'gameType',
  History: 'history',
  Id: 'id',
  IsFinished: 'isFinished',
  Score: 'score',
  UpdatedAt: 'updatedAt',
  UserId: 'userId'
} as const;

export type ResultScalarFieldEnum = typeof ResultScalarFieldEnum[keyof typeof ResultScalarFieldEnum];
export type ResultScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<ResultScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<ResultScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<ResultScalarWhereInput>>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly gameId?: InputMaybe<StringFilter>;
  readonly gameType?: InputMaybe<EnumGameTypeFilter>;
  readonly history?: InputMaybe<StringNullableFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly isFinished?: InputMaybe<BoolFilter>;
  readonly score?: InputMaybe<IntNullableFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type ResultScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<ResultScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<ResultScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<ResultScalarWhereWithAggregatesInput>>;
  readonly createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly gameId?: InputMaybe<StringWithAggregatesFilter>;
  readonly gameType?: InputMaybe<EnumGameTypeWithAggregatesFilter>;
  readonly history?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly isFinished?: InputMaybe<BoolWithAggregatesFilter>;
  readonly score?: InputMaybe<IntNullableWithAggregatesFilter>;
  readonly updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type ResultSumAggregate = {
  readonly __typename?: 'ResultSumAggregate';
  readonly score?: Maybe<Scalars['Int']>;
};

export type ResultSumOrderByAggregateInput = {
  readonly score?: InputMaybe<SortOrder>;
};

export type ResultUpdateInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly game?: InputMaybe<GameUpdateOneRequiredWithoutResultsNestedInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly history?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly isFinished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly score?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly user?: InputMaybe<UserUpdateOneRequiredWithoutResultsNestedInput>;
};

export type ResultUpdateManyMutationInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly history?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly isFinished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly score?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResultUpdateManyWithWhereWithoutGameInput = {
  readonly data: ResultUpdateManyMutationInput;
  readonly where: ResultScalarWhereInput;
};

export type ResultUpdateManyWithWhereWithoutUserInput = {
  readonly data: ResultUpdateManyMutationInput;
  readonly where: ResultScalarWhereInput;
};

export type ResultUpdateManyWithoutGameNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<ResultCreateOrConnectWithoutGameInput>>;
  readonly create?: InputMaybe<ReadonlyArray<ResultCreateWithoutGameInput>>;
  readonly createMany?: InputMaybe<ResultCreateManyGameInputEnvelope>;
  readonly delete?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<ResultScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<ResultUpdateWithWhereUniqueWithoutGameInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<ResultUpdateManyWithWhereWithoutGameInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<ResultUpsertWithWhereUniqueWithoutGameInput>>;
};

export type ResultUpdateManyWithoutUserNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<ResultCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<ResultCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<ResultCreateManyUserInputEnvelope>;
  readonly delete?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<ResultScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<ResultWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<ResultUpdateWithWhereUniqueWithoutUserInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<ResultUpdateManyWithWhereWithoutUserInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<ResultUpsertWithWhereUniqueWithoutUserInput>>;
};

export type ResultUpdateWithWhereUniqueWithoutGameInput = {
  readonly data: ResultUpdateWithoutGameInput;
  readonly where: ResultWhereUniqueInput;
};

export type ResultUpdateWithWhereUniqueWithoutUserInput = {
  readonly data: ResultUpdateWithoutUserInput;
  readonly where: ResultWhereUniqueInput;
};

export type ResultUpdateWithoutGameInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly history?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly isFinished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly score?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly user?: InputMaybe<UserUpdateOneRequiredWithoutResultsNestedInput>;
};

export type ResultUpdateWithoutUserInput = {
  readonly createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly game?: InputMaybe<GameUpdateOneRequiredWithoutResultsNestedInput>;
  readonly gameType?: InputMaybe<EnumGameTypeFieldUpdateOperationsInput>;
  readonly history?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly isFinished?: InputMaybe<BoolFieldUpdateOperationsInput>;
  readonly score?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  readonly updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResultUpsertWithWhereUniqueWithoutGameInput = {
  readonly create: ResultCreateWithoutGameInput;
  readonly update: ResultUpdateWithoutGameInput;
  readonly where: ResultWhereUniqueInput;
};

export type ResultUpsertWithWhereUniqueWithoutUserInput = {
  readonly create: ResultCreateWithoutUserInput;
  readonly update: ResultUpdateWithoutUserInput;
  readonly where: ResultWhereUniqueInput;
};

export type ResultWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<ResultWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<ResultWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<ResultWhereInput>>;
  readonly createdAt?: InputMaybe<DateTimeFilter>;
  readonly game?: InputMaybe<GameRelationFilter>;
  readonly gameId?: InputMaybe<StringFilter>;
  readonly gameType?: InputMaybe<EnumGameTypeFilter>;
  readonly history?: InputMaybe<StringNullableFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly isFinished?: InputMaybe<BoolFilter>;
  readonly score?: InputMaybe<IntNullableFilter>;
  readonly updatedAt?: InputMaybe<DateTimeFilter>;
  readonly user?: InputMaybe<UserRelationFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type ResultWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
};

export type Session = {
  readonly __typename?: 'Session';
  readonly expires: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly sessionToken: Scalars['String'];
  readonly user: User;
  readonly userId: Scalars['String'];
};

export type SessionCountAggregate = {
  readonly __typename?: 'SessionCountAggregate';
  readonly _all: Scalars['Int'];
  readonly expires: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly sessionToken: Scalars['Int'];
  readonly userId: Scalars['Int'];
};

export type SessionCountOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type SessionCreateInput = {
  readonly expires: Scalars['DateTime'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken: Scalars['String'];
  readonly user: UserCreateNestedOneWithoutSessionsInput;
};

export type SessionCreateManyInput = {
  readonly expires: Scalars['DateTime'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type SessionCreateManyUserInput = {
  readonly expires: Scalars['DateTime'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken: Scalars['String'];
};

export type SessionCreateManyUserInputEnvelope = {
  readonly data: ReadonlyArray<SessionCreateManyUserInput>;
  readonly skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SessionCreateNestedManyWithoutUserInput = {
  readonly connect?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<SessionCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<SessionCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
};

export type SessionCreateOrConnectWithoutUserInput = {
  readonly create: SessionCreateWithoutUserInput;
  readonly where: SessionWhereUniqueInput;
};

export type SessionCreateWithoutUserInput = {
  readonly expires: Scalars['DateTime'];
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken: Scalars['String'];
};

export type SessionGroupBy = {
  readonly __typename?: 'SessionGroupBy';
  readonly _count?: Maybe<SessionCountAggregate>;
  readonly _max?: Maybe<SessionMaxAggregate>;
  readonly _min?: Maybe<SessionMinAggregate>;
  readonly expires: Scalars['DateTime'];
  readonly id: Scalars['String'];
  readonly sessionToken: Scalars['String'];
  readonly userId: Scalars['String'];
};

export type SessionListRelationFilter = {
  readonly every?: InputMaybe<SessionWhereInput>;
  readonly none?: InputMaybe<SessionWhereInput>;
  readonly some?: InputMaybe<SessionWhereInput>;
};

export type SessionMaxAggregate = {
  readonly __typename?: 'SessionMaxAggregate';
  readonly expires?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly sessionToken?: Maybe<Scalars['String']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type SessionMaxOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type SessionMinAggregate = {
  readonly __typename?: 'SessionMinAggregate';
  readonly expires?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly sessionToken?: Maybe<Scalars['String']>;
  readonly userId?: Maybe<Scalars['String']>;
};

export type SessionMinOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type SessionOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type SessionOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<SessionCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<SessionMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<SessionMinOrderByAggregateInput>;
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly userId?: InputMaybe<SortOrder>;
};

export type SessionOrderByWithRelationInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly sessionToken?: InputMaybe<SortOrder>;
  readonly user?: InputMaybe<UserOrderByWithRelationInput>;
  readonly userId?: InputMaybe<SortOrder>;
};

export const SessionScalarFieldEnum = {
  Expires: 'expires',
  Id: 'id',
  SessionToken: 'sessionToken',
  UserId: 'userId'
} as const;

export type SessionScalarFieldEnum = typeof SessionScalarFieldEnum[keyof typeof SessionScalarFieldEnum];
export type SessionScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<SessionScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<SessionScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<SessionScalarWhereInput>>;
  readonly expires?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly sessionToken?: InputMaybe<StringFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type SessionScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<SessionScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<SessionScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<SessionScalarWhereWithAggregatesInput>>;
  readonly expires?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly sessionToken?: InputMaybe<StringWithAggregatesFilter>;
  readonly userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type SessionUpdateInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly user?: InputMaybe<UserUpdateOneRequiredWithoutSessionsNestedInput>;
};

export type SessionUpdateManyMutationInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SessionUpdateManyWithWhereWithoutUserInput = {
  readonly data: SessionUpdateManyMutationInput;
  readonly where: SessionScalarWhereInput;
};

export type SessionUpdateManyWithoutUserNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<SessionCreateOrConnectWithoutUserInput>>;
  readonly create?: InputMaybe<ReadonlyArray<SessionCreateWithoutUserInput>>;
  readonly createMany?: InputMaybe<SessionCreateManyUserInputEnvelope>;
  readonly delete?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<SessionScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<SessionWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<SessionUpdateWithWhereUniqueWithoutUserInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<SessionUpdateManyWithWhereWithoutUserInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<SessionUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SessionUpdateWithWhereUniqueWithoutUserInput = {
  readonly data: SessionUpdateWithoutUserInput;
  readonly where: SessionWhereUniqueInput;
};

export type SessionUpdateWithoutUserInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly sessionToken?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SessionUpsertWithWhereUniqueWithoutUserInput = {
  readonly create: SessionCreateWithoutUserInput;
  readonly update: SessionUpdateWithoutUserInput;
  readonly where: SessionWhereUniqueInput;
};

export type SessionWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<SessionWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<SessionWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<SessionWhereInput>>;
  readonly expires?: InputMaybe<DateTimeFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly sessionToken?: InputMaybe<StringFilter>;
  readonly user?: InputMaybe<UserRelationFilter>;
  readonly userId?: InputMaybe<StringFilter>;
};

export type SessionWhereUniqueInput = {
  readonly id?: InputMaybe<Scalars['String']>;
  readonly sessionToken?: InputMaybe<Scalars['String']>;
};

export const SortOrder = {
  Asc: 'asc',
  Desc: 'desc'
} as const;

export type SortOrder = typeof SortOrder[keyof typeof SortOrder];
export type StringFieldUpdateOperationsInput = {
  readonly set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly mode?: InputMaybe<QueryMode>;
  readonly not?: InputMaybe<NestedStringFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly mode?: InputMaybe<QueryMode>;
  readonly not?: InputMaybe<NestedStringNullableFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntNullableFilter>;
  readonly _max?: InputMaybe<NestedStringNullableFilter>;
  readonly _min?: InputMaybe<NestedStringNullableFilter>;
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly mode?: InputMaybe<QueryMode>;
  readonly not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  readonly _count?: InputMaybe<NestedIntFilter>;
  readonly _max?: InputMaybe<NestedStringFilter>;
  readonly _min?: InputMaybe<NestedStringFilter>;
  readonly contains?: InputMaybe<Scalars['String']>;
  readonly endsWith?: InputMaybe<Scalars['String']>;
  readonly equals?: InputMaybe<Scalars['String']>;
  readonly gt?: InputMaybe<Scalars['String']>;
  readonly gte?: InputMaybe<Scalars['String']>;
  readonly in?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly lt?: InputMaybe<Scalars['String']>;
  readonly lte?: InputMaybe<Scalars['String']>;
  readonly mode?: InputMaybe<QueryMode>;
  readonly not?: InputMaybe<NestedStringWithAggregatesFilter>;
  readonly notIn?: InputMaybe<ReadonlyArray<Scalars['String']>>;
  readonly startsWith?: InputMaybe<Scalars['String']>;
};

export type User = {
  readonly __typename?: 'User';
  readonly _count?: Maybe<UserCount>;
  readonly accounts: ReadonlyArray<Account>;
  readonly description?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly emailVerified?: Maybe<Scalars['DateTime']>;
  readonly friends: ReadonlyArray<User>;
  readonly friendsRelation: ReadonlyArray<User>;
  readonly groups: ReadonlyArray<Group>;
  readonly id: Scalars['String'];
  readonly image?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
  readonly results: ReadonlyArray<Result>;
  readonly sessions: ReadonlyArray<Session>;
};


export type UserAccountsArgs = {
  cursor?: InputMaybe<AccountWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<AccountScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<AccountOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccountWhereInput>;
};


export type UserFriendsArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type UserFriendsRelationArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type UserGroupsArgs = {
  cursor?: InputMaybe<GroupWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<GroupScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<GroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<GroupWhereInput>;
};


export type UserResultsArgs = {
  cursor?: InputMaybe<ResultWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<ResultScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<ResultOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResultWhereInput>;
};


export type UserSessionsArgs = {
  cursor?: InputMaybe<SessionWhereUniqueInput>;
  distinct?: InputMaybe<ReadonlyArray<SessionScalarFieldEnum>>;
  orderBy?: InputMaybe<ReadonlyArray<SessionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SessionWhereInput>;
};

export type UserCount = {
  readonly __typename?: 'UserCount';
  readonly accounts: Scalars['Int'];
  readonly friends: Scalars['Int'];
  readonly friendsRelation: Scalars['Int'];
  readonly groups: Scalars['Int'];
  readonly results: Scalars['Int'];
  readonly sessions: Scalars['Int'];
};

export type UserCountAggregate = {
  readonly __typename?: 'UserCountAggregate';
  readonly _all: Scalars['Int'];
  readonly description: Scalars['Int'];
  readonly email: Scalars['Int'];
  readonly emailVerified: Scalars['Int'];
  readonly id: Scalars['Int'];
  readonly image: Scalars['Int'];
  readonly name: Scalars['Int'];
};

export type UserCountOrderByAggregateInput = {
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
};

export type UserCreateInput = {
  readonly accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly friends?: InputMaybe<UserCreateNestedManyWithoutFriendsRelationInput>;
  readonly friendsRelation?: InputMaybe<UserCreateNestedManyWithoutFriendsInput>;
  readonly groups?: InputMaybe<GroupCreateNestedManyWithoutUsersInput>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly results?: InputMaybe<ResultCreateNestedManyWithoutUserInput>;
  readonly sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
};

export type UserCreateManyInput = {
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
};

export type UserCreateNestedManyWithoutFriendsInput = {
  readonly connect?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<UserCreateOrConnectWithoutFriendsInput>>;
  readonly create?: InputMaybe<ReadonlyArray<UserCreateWithoutFriendsInput>>;
};

export type UserCreateNestedManyWithoutFriendsRelationInput = {
  readonly connect?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<UserCreateOrConnectWithoutFriendsRelationInput>>;
  readonly create?: InputMaybe<ReadonlyArray<UserCreateWithoutFriendsRelationInput>>;
};

export type UserCreateNestedManyWithoutGroupsInput = {
  readonly connect?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<UserCreateOrConnectWithoutGroupsInput>>;
  readonly create?: InputMaybe<ReadonlyArray<UserCreateWithoutGroupsInput>>;
};

export type UserCreateNestedOneWithoutAccountsInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAccountsInput>;
  readonly create?: InputMaybe<UserCreateWithoutAccountsInput>;
};

export type UserCreateNestedOneWithoutResultsInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutResultsInput>;
  readonly create?: InputMaybe<UserCreateWithoutResultsInput>;
};

export type UserCreateNestedOneWithoutSessionsInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSessionsInput>;
  readonly create?: InputMaybe<UserCreateWithoutSessionsInput>;
};

export type UserCreateOrConnectWithoutAccountsInput = {
  readonly create: UserCreateWithoutAccountsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFriendsInput = {
  readonly create: UserCreateWithoutFriendsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutFriendsRelationInput = {
  readonly create: UserCreateWithoutFriendsRelationInput;
  readonly where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutGroupsInput = {
  readonly create: UserCreateWithoutGroupsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutResultsInput = {
  readonly create: UserCreateWithoutResultsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSessionsInput = {
  readonly create: UserCreateWithoutSessionsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserCreateWithoutAccountsInput = {
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly friends?: InputMaybe<UserCreateNestedManyWithoutFriendsRelationInput>;
  readonly friendsRelation?: InputMaybe<UserCreateNestedManyWithoutFriendsInput>;
  readonly groups?: InputMaybe<GroupCreateNestedManyWithoutUsersInput>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly results?: InputMaybe<ResultCreateNestedManyWithoutUserInput>;
  readonly sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutFriendsInput = {
  readonly accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly friendsRelation?: InputMaybe<UserCreateNestedManyWithoutFriendsInput>;
  readonly groups?: InputMaybe<GroupCreateNestedManyWithoutUsersInput>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly results?: InputMaybe<ResultCreateNestedManyWithoutUserInput>;
  readonly sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutFriendsRelationInput = {
  readonly accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly friends?: InputMaybe<UserCreateNestedManyWithoutFriendsRelationInput>;
  readonly groups?: InputMaybe<GroupCreateNestedManyWithoutUsersInput>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly results?: InputMaybe<ResultCreateNestedManyWithoutUserInput>;
  readonly sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutGroupsInput = {
  readonly accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly friends?: InputMaybe<UserCreateNestedManyWithoutFriendsRelationInput>;
  readonly friendsRelation?: InputMaybe<UserCreateNestedManyWithoutFriendsInput>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly results?: InputMaybe<ResultCreateNestedManyWithoutUserInput>;
  readonly sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutResultsInput = {
  readonly accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly friends?: InputMaybe<UserCreateNestedManyWithoutFriendsRelationInput>;
  readonly friendsRelation?: InputMaybe<UserCreateNestedManyWithoutFriendsInput>;
  readonly groups?: InputMaybe<GroupCreateNestedManyWithoutUsersInput>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly sessions?: InputMaybe<SessionCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutSessionsInput = {
  readonly accounts?: InputMaybe<AccountCreateNestedManyWithoutUserInput>;
  readonly description?: InputMaybe<Scalars['String']>;
  readonly email?: InputMaybe<Scalars['String']>;
  readonly emailVerified?: InputMaybe<Scalars['DateTime']>;
  readonly friends?: InputMaybe<UserCreateNestedManyWithoutFriendsRelationInput>;
  readonly friendsRelation?: InputMaybe<UserCreateNestedManyWithoutFriendsInput>;
  readonly groups?: InputMaybe<GroupCreateNestedManyWithoutUsersInput>;
  readonly id?: InputMaybe<Scalars['String']>;
  readonly image?: InputMaybe<Scalars['String']>;
  readonly name?: InputMaybe<Scalars['String']>;
  readonly results?: InputMaybe<ResultCreateNestedManyWithoutUserInput>;
};

export type UserGroupBy = {
  readonly __typename?: 'UserGroupBy';
  readonly _count?: Maybe<UserCountAggregate>;
  readonly _max?: Maybe<UserMaxAggregate>;
  readonly _min?: Maybe<UserMinAggregate>;
  readonly description?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly emailVerified?: Maybe<Scalars['DateTime']>;
  readonly id: Scalars['String'];
  readonly image?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type UserListRelationFilter = {
  readonly every?: InputMaybe<UserWhereInput>;
  readonly none?: InputMaybe<UserWhereInput>;
  readonly some?: InputMaybe<UserWhereInput>;
};

export type UserMaxAggregate = {
  readonly __typename?: 'UserMaxAggregate';
  readonly description?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly emailVerified?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly image?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type UserMaxOrderByAggregateInput = {
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
};

export type UserMinAggregate = {
  readonly __typename?: 'UserMinAggregate';
  readonly description?: Maybe<Scalars['String']>;
  readonly email?: Maybe<Scalars['String']>;
  readonly emailVerified?: Maybe<Scalars['DateTime']>;
  readonly id?: Maybe<Scalars['String']>;
  readonly image?: Maybe<Scalars['String']>;
  readonly name?: Maybe<Scalars['String']>;
};

export type UserMinOrderByAggregateInput = {
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
};

export type UserOrderByRelationAggregateInput = {
  readonly _count?: InputMaybe<SortOrder>;
};

export type UserOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<UserCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<UserMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<UserMinOrderByAggregateInput>;
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  readonly accounts?: InputMaybe<AccountOrderByRelationAggregateInput>;
  readonly description?: InputMaybe<SortOrder>;
  readonly email?: InputMaybe<SortOrder>;
  readonly emailVerified?: InputMaybe<SortOrder>;
  readonly friends?: InputMaybe<UserOrderByRelationAggregateInput>;
  readonly friendsRelation?: InputMaybe<UserOrderByRelationAggregateInput>;
  readonly groups?: InputMaybe<GroupOrderByRelationAggregateInput>;
  readonly id?: InputMaybe<SortOrder>;
  readonly image?: InputMaybe<SortOrder>;
  readonly name?: InputMaybe<SortOrder>;
  readonly results?: InputMaybe<ResultOrderByRelationAggregateInput>;
  readonly sessions?: InputMaybe<SessionOrderByRelationAggregateInput>;
};

export type UserRelationFilter = {
  readonly is?: InputMaybe<UserWhereInput>;
  readonly isNot?: InputMaybe<UserWhereInput>;
};

export const UserScalarFieldEnum = {
  Description: 'description',
  Email: 'email',
  EmailVerified: 'emailVerified',
  Id: 'id',
  Image: 'image',
  Name: 'name'
} as const;

export type UserScalarFieldEnum = typeof UserScalarFieldEnum[keyof typeof UserScalarFieldEnum];
export type UserScalarWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<UserScalarWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<UserScalarWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<UserScalarWhereInput>>;
  readonly description?: InputMaybe<StringNullableFilter>;
  readonly email?: InputMaybe<StringNullableFilter>;
  readonly emailVerified?: InputMaybe<DateTimeNullableFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly image?: InputMaybe<StringNullableFilter>;
  readonly name?: InputMaybe<StringNullableFilter>;
};

export type UserScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<UserScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<UserScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<UserScalarWhereWithAggregatesInput>>;
  readonly description?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly email?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly emailVerified?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  readonly id?: InputMaybe<StringWithAggregatesFilter>;
  readonly image?: InputMaybe<StringNullableWithAggregatesFilter>;
  readonly name?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type UserUpdateInput = {
  readonly accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly friends?: InputMaybe<UserUpdateManyWithoutFriendsRelationNestedInput>;
  readonly friendsRelation?: InputMaybe<UserUpdateManyWithoutFriendsNestedInput>;
  readonly groups?: InputMaybe<GroupUpdateManyWithoutUsersNestedInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly results?: InputMaybe<ResultUpdateManyWithoutUserNestedInput>;
  readonly sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateManyMutationInput = {
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithWhereWithoutFriendsInput = {
  readonly data: UserUpdateManyMutationInput;
  readonly where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutFriendsRelationInput = {
  readonly data: UserUpdateManyMutationInput;
  readonly where: UserScalarWhereInput;
};

export type UserUpdateManyWithWhereWithoutGroupsInput = {
  readonly data: UserUpdateManyMutationInput;
  readonly where: UserScalarWhereInput;
};

export type UserUpdateManyWithoutFriendsNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<UserCreateOrConnectWithoutFriendsInput>>;
  readonly create?: InputMaybe<ReadonlyArray<UserCreateWithoutFriendsInput>>;
  readonly delete?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<UserScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<UserUpdateWithWhereUniqueWithoutFriendsInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<UserUpdateManyWithWhereWithoutFriendsInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<UserUpsertWithWhereUniqueWithoutFriendsInput>>;
};

export type UserUpdateManyWithoutFriendsRelationNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<UserCreateOrConnectWithoutFriendsRelationInput>>;
  readonly create?: InputMaybe<ReadonlyArray<UserCreateWithoutFriendsRelationInput>>;
  readonly delete?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<UserScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<UserUpdateWithWhereUniqueWithoutFriendsRelationInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<UserUpdateManyWithWhereWithoutFriendsRelationInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<UserUpsertWithWhereUniqueWithoutFriendsRelationInput>>;
};

export type UserUpdateManyWithoutGroupsNestedInput = {
  readonly connect?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly connectOrCreate?: InputMaybe<ReadonlyArray<UserCreateOrConnectWithoutGroupsInput>>;
  readonly create?: InputMaybe<ReadonlyArray<UserCreateWithoutGroupsInput>>;
  readonly delete?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly deleteMany?: InputMaybe<ReadonlyArray<UserScalarWhereInput>>;
  readonly disconnect?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly set?: InputMaybe<ReadonlyArray<UserWhereUniqueInput>>;
  readonly update?: InputMaybe<ReadonlyArray<UserUpdateWithWhereUniqueWithoutGroupsInput>>;
  readonly updateMany?: InputMaybe<ReadonlyArray<UserUpdateManyWithWhereWithoutGroupsInput>>;
  readonly upsert?: InputMaybe<ReadonlyArray<UserUpsertWithWhereUniqueWithoutGroupsInput>>;
};

export type UserUpdateOneRequiredWithoutAccountsNestedInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAccountsInput>;
  readonly create?: InputMaybe<UserCreateWithoutAccountsInput>;
  readonly update?: InputMaybe<UserUpdateWithoutAccountsInput>;
  readonly upsert?: InputMaybe<UserUpsertWithoutAccountsInput>;
};

export type UserUpdateOneRequiredWithoutResultsNestedInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutResultsInput>;
  readonly create?: InputMaybe<UserCreateWithoutResultsInput>;
  readonly update?: InputMaybe<UserUpdateWithoutResultsInput>;
  readonly upsert?: InputMaybe<UserUpsertWithoutResultsInput>;
};

export type UserUpdateOneRequiredWithoutSessionsNestedInput = {
  readonly connect?: InputMaybe<UserWhereUniqueInput>;
  readonly connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSessionsInput>;
  readonly create?: InputMaybe<UserCreateWithoutSessionsInput>;
  readonly update?: InputMaybe<UserUpdateWithoutSessionsInput>;
  readonly upsert?: InputMaybe<UserUpsertWithoutSessionsInput>;
};

export type UserUpdateWithWhereUniqueWithoutFriendsInput = {
  readonly data: UserUpdateWithoutFriendsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutFriendsRelationInput = {
  readonly data: UserUpdateWithoutFriendsRelationInput;
  readonly where: UserWhereUniqueInput;
};

export type UserUpdateWithWhereUniqueWithoutGroupsInput = {
  readonly data: UserUpdateWithoutGroupsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserUpdateWithoutAccountsInput = {
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly friends?: InputMaybe<UserUpdateManyWithoutFriendsRelationNestedInput>;
  readonly friendsRelation?: InputMaybe<UserUpdateManyWithoutFriendsNestedInput>;
  readonly groups?: InputMaybe<GroupUpdateManyWithoutUsersNestedInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly results?: InputMaybe<ResultUpdateManyWithoutUserNestedInput>;
  readonly sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutFriendsInput = {
  readonly accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly friendsRelation?: InputMaybe<UserUpdateManyWithoutFriendsNestedInput>;
  readonly groups?: InputMaybe<GroupUpdateManyWithoutUsersNestedInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly results?: InputMaybe<ResultUpdateManyWithoutUserNestedInput>;
  readonly sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutFriendsRelationInput = {
  readonly accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly friends?: InputMaybe<UserUpdateManyWithoutFriendsRelationNestedInput>;
  readonly groups?: InputMaybe<GroupUpdateManyWithoutUsersNestedInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly results?: InputMaybe<ResultUpdateManyWithoutUserNestedInput>;
  readonly sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutGroupsInput = {
  readonly accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly friends?: InputMaybe<UserUpdateManyWithoutFriendsRelationNestedInput>;
  readonly friendsRelation?: InputMaybe<UserUpdateManyWithoutFriendsNestedInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly results?: InputMaybe<ResultUpdateManyWithoutUserNestedInput>;
  readonly sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutResultsInput = {
  readonly accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly friends?: InputMaybe<UserUpdateManyWithoutFriendsRelationNestedInput>;
  readonly friendsRelation?: InputMaybe<UserUpdateManyWithoutFriendsNestedInput>;
  readonly groups?: InputMaybe<GroupUpdateManyWithoutUsersNestedInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly sessions?: InputMaybe<SessionUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutSessionsInput = {
  readonly accounts?: InputMaybe<AccountUpdateManyWithoutUserNestedInput>;
  readonly description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly emailVerified?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  readonly friends?: InputMaybe<UserUpdateManyWithoutFriendsRelationNestedInput>;
  readonly friendsRelation?: InputMaybe<UserUpdateManyWithoutFriendsNestedInput>;
  readonly groups?: InputMaybe<GroupUpdateManyWithoutUsersNestedInput>;
  readonly id?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly image?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  readonly results?: InputMaybe<ResultUpdateManyWithoutUserNestedInput>;
};

export type UserUpsertWithWhereUniqueWithoutFriendsInput = {
  readonly create: UserCreateWithoutFriendsInput;
  readonly update: UserUpdateWithoutFriendsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutFriendsRelationInput = {
  readonly create: UserCreateWithoutFriendsRelationInput;
  readonly update: UserUpdateWithoutFriendsRelationInput;
  readonly where: UserWhereUniqueInput;
};

export type UserUpsertWithWhereUniqueWithoutGroupsInput = {
  readonly create: UserCreateWithoutGroupsInput;
  readonly update: UserUpdateWithoutGroupsInput;
  readonly where: UserWhereUniqueInput;
};

export type UserUpsertWithoutAccountsInput = {
  readonly create: UserCreateWithoutAccountsInput;
  readonly update: UserUpdateWithoutAccountsInput;
};

export type UserUpsertWithoutResultsInput = {
  readonly create: UserCreateWithoutResultsInput;
  readonly update: UserUpdateWithoutResultsInput;
};

export type UserUpsertWithoutSessionsInput = {
  readonly create: UserCreateWithoutSessionsInput;
  readonly update: UserUpdateWithoutSessionsInput;
};

export type UserWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<UserWhereInput>>;
  readonly accounts?: InputMaybe<AccountListRelationFilter>;
  readonly description?: InputMaybe<StringNullableFilter>;
  readonly email?: InputMaybe<StringNullableFilter>;
  readonly emailVerified?: InputMaybe<DateTimeNullableFilter>;
  readonly friends?: InputMaybe<UserListRelationFilter>;
  readonly friendsRelation?: InputMaybe<UserListRelationFilter>;
  readonly groups?: InputMaybe<GroupListRelationFilter>;
  readonly id?: InputMaybe<StringFilter>;
  readonly image?: InputMaybe<StringNullableFilter>;
  readonly name?: InputMaybe<StringNullableFilter>;
  readonly results?: InputMaybe<ResultListRelationFilter>;
  readonly sessions?: InputMaybe<SessionListRelationFilter>;
};

export type UserWhereUniqueInput = {
  readonly email?: InputMaybe<Scalars['String']>;
  readonly id?: InputMaybe<Scalars['String']>;
};

export type VerificationToken = {
  readonly __typename?: 'VerificationToken';
  readonly expires: Scalars['DateTime'];
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenCountAggregate = {
  readonly __typename?: 'VerificationTokenCountAggregate';
  readonly _all: Scalars['Int'];
  readonly expires: Scalars['Int'];
  readonly identifier: Scalars['Int'];
  readonly token: Scalars['Int'];
};

export type VerificationTokenCountOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export type VerificationTokenCreateInput = {
  readonly expires: Scalars['DateTime'];
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenCreateManyInput = {
  readonly expires: Scalars['DateTime'];
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenGroupBy = {
  readonly __typename?: 'VerificationTokenGroupBy';
  readonly _count?: Maybe<VerificationTokenCountAggregate>;
  readonly _max?: Maybe<VerificationTokenMaxAggregate>;
  readonly _min?: Maybe<VerificationTokenMinAggregate>;
  readonly expires: Scalars['DateTime'];
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenIdentifierTokenCompoundUniqueInput = {
  readonly identifier: Scalars['String'];
  readonly token: Scalars['String'];
};

export type VerificationTokenMaxAggregate = {
  readonly __typename?: 'VerificationTokenMaxAggregate';
  readonly expires?: Maybe<Scalars['DateTime']>;
  readonly identifier?: Maybe<Scalars['String']>;
  readonly token?: Maybe<Scalars['String']>;
};

export type VerificationTokenMaxOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export type VerificationTokenMinAggregate = {
  readonly __typename?: 'VerificationTokenMinAggregate';
  readonly expires?: Maybe<Scalars['DateTime']>;
  readonly identifier?: Maybe<Scalars['String']>;
  readonly token?: Maybe<Scalars['String']>;
};

export type VerificationTokenMinOrderByAggregateInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export type VerificationTokenOrderByWithAggregationInput = {
  readonly _count?: InputMaybe<VerificationTokenCountOrderByAggregateInput>;
  readonly _max?: InputMaybe<VerificationTokenMaxOrderByAggregateInput>;
  readonly _min?: InputMaybe<VerificationTokenMinOrderByAggregateInput>;
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export type VerificationTokenOrderByWithRelationInput = {
  readonly expires?: InputMaybe<SortOrder>;
  readonly identifier?: InputMaybe<SortOrder>;
  readonly token?: InputMaybe<SortOrder>;
};

export const VerificationTokenScalarFieldEnum = {
  Expires: 'expires',
  Identifier: 'identifier',
  Token: 'token'
} as const;

export type VerificationTokenScalarFieldEnum = typeof VerificationTokenScalarFieldEnum[keyof typeof VerificationTokenScalarFieldEnum];
export type VerificationTokenScalarWhereWithAggregatesInput = {
  readonly AND?: InputMaybe<ReadonlyArray<VerificationTokenScalarWhereWithAggregatesInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<VerificationTokenScalarWhereWithAggregatesInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<VerificationTokenScalarWhereWithAggregatesInput>>;
  readonly expires?: InputMaybe<DateTimeWithAggregatesFilter>;
  readonly identifier?: InputMaybe<StringWithAggregatesFilter>;
  readonly token?: InputMaybe<StringWithAggregatesFilter>;
};

export type VerificationTokenUpdateInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VerificationTokenUpdateManyMutationInput = {
  readonly expires?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  readonly identifier?: InputMaybe<StringFieldUpdateOperationsInput>;
  readonly token?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type VerificationTokenWhereInput = {
  readonly AND?: InputMaybe<ReadonlyArray<VerificationTokenWhereInput>>;
  readonly NOT?: InputMaybe<ReadonlyArray<VerificationTokenWhereInput>>;
  readonly OR?: InputMaybe<ReadonlyArray<VerificationTokenWhereInput>>;
  readonly expires?: InputMaybe<DateTimeFilter>;
  readonly identifier?: InputMaybe<StringFilter>;
  readonly token?: InputMaybe<StringFilter>;
};

export type VerificationTokenWhereUniqueInput = {
  readonly identifier_token?: InputMaybe<VerificationTokenIdentifierTokenCompoundUniqueInput>;
  readonly token?: InputMaybe<Scalars['String']>;
};

export type GetSignedInUserQueryVariables = Exact<{ [key: string]: never; }>;


export type GetSignedInUserQuery = { readonly __typename?: 'Query', readonly getSignedInUser?: { readonly __typename?: 'User', readonly id: string, readonly email?: string | undefined } | undefined };

export type GetUserQueryVariables = Exact<{
  email: Scalars['String'];
}>;


export type GetUserQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly email?: string | undefined, readonly image?: string | undefined, readonly id: string, readonly friends: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly image?: string | undefined, readonly description?: string | undefined, readonly name?: string | undefined }> } | undefined };

export type GetUserByIdQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetUserByIdQuery = { readonly __typename?: 'Query', readonly user?: { readonly __typename?: 'User', readonly email?: string | undefined, readonly image?: string | undefined, readonly id: string, readonly description?: string | undefined, readonly name?: string | undefined } | undefined };

export type GetUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUsersQuery = { readonly __typename?: 'Query', readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string }> };

export type AddFriendMutationVariables = Exact<{
  email: Scalars['String'];
  friendId: Scalars['String'];
}>;


export type AddFriendMutation = { readonly __typename?: 'Mutation', readonly addFriend: { readonly __typename?: 'User', readonly friends: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string }> } };

export type CreateGroupMutationVariables = Exact<{
  name: Scalars['String'];
  end: Scalars['DateTime'];
  friendIds?: InputMaybe<ReadonlyArray<UserWhereUniqueInput> | UserWhereUniqueInput>;
}>;


export type CreateGroupMutation = { readonly __typename?: 'Mutation', readonly createOneGroup: { readonly __typename?: 'Group', readonly id: string } };

export type GetGroupQueryVariables = Exact<{
  groupId: Scalars['String'];
}>;


export type GetGroupQuery = { readonly __typename?: 'Query', readonly group?: { readonly __typename?: 'Group', readonly createdAt: string, readonly endAt: string, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string }> } | undefined };

export type GetGroupGamesQueryVariables = Exact<{
  startTime: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
}>;


export type GetGroupGamesQuery = { readonly __typename?: 'Query', readonly games: ReadonlyArray<{ readonly __typename?: 'Game', readonly id: string, readonly createdAt: string, readonly gameType: GameType, readonly seed: number }> };

export type GetScoresQueryVariables = Exact<{
  userIds: ReadonlyArray<Scalars['String']> | Scalars['String'];
  startTime: Scalars['DateTime'];
  endTime: Scalars['DateTime'];
}>;


export type GetScoresQuery = { readonly __typename?: 'Query', readonly results: ReadonlyArray<{ readonly __typename?: 'Result', readonly id: string, readonly score?: number | undefined, readonly isFinished: boolean, readonly gameId: string, readonly updatedAt: string, readonly user: { readonly __typename?: 'User', readonly id: string, readonly image?: string | undefined, readonly description?: string | undefined, readonly name?: string | undefined } }>, readonly games: ReadonlyArray<{ readonly __typename?: 'Game', readonly id: string }> };

export type GetGroupsQueryVariables = Exact<{
  email: Scalars['String'];
  now: Scalars['DateTime'];
}>;


export type GetGroupsQuery = { readonly __typename?: 'Query', readonly groups: ReadonlyArray<{ readonly __typename?: 'Group', readonly id: string, readonly name: string, readonly endAt: string, readonly gameType: GameType, readonly users: ReadonlyArray<{ readonly __typename?: 'User', readonly id: string, readonly image?: string | undefined }> }> };

export type GetLatestResultQueryVariables = Exact<{
  email: Scalars['String'];
  gameType: GameType;
}>;


export type GetLatestResultQuery = { readonly __typename?: 'Query', readonly getResultForGameType?: { readonly __typename?: 'Result', readonly id: string, readonly createdAt: string, readonly score?: number | undefined, readonly isFinished: boolean, readonly userId: string, readonly gameId: string } | undefined };


export const GetSignedInUserDocument = gql`
    query getSignedInUser {
  getSignedInUser {
    id
    email
  }
}
    `;

/**
 * __useGetSignedInUserQuery__
 *
 * To run a query within a React component, call `useGetSignedInUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetSignedInUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetSignedInUserQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetSignedInUserQuery(baseOptions?: Apollo.QueryHookOptions<GetSignedInUserQuery, GetSignedInUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetSignedInUserQuery, GetSignedInUserQueryVariables>(GetSignedInUserDocument, options);
      }
export function useGetSignedInUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetSignedInUserQuery, GetSignedInUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetSignedInUserQuery, GetSignedInUserQueryVariables>(GetSignedInUserDocument, options);
        }
export type GetSignedInUserQueryHookResult = ReturnType<typeof useGetSignedInUserQuery>;
export type GetSignedInUserLazyQueryHookResult = ReturnType<typeof useGetSignedInUserLazyQuery>;
export type GetSignedInUserQueryResult = Apollo.QueryResult<GetSignedInUserQuery, GetSignedInUserQueryVariables>;
export const GetUserDocument = gql`
    query getUser($email: String!) {
  user(where: {email: $email}) {
    email
    image
    id
    friends {
      id
      image
      description
      name
    }
  }
}
    `;

/**
 * __useGetUserQuery__
 *
 * To run a query within a React component, call `useGetUserQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserQuery({
 *   variables: {
 *      email: // value for 'email'
 *   },
 * });
 */
export function useGetUserQuery(baseOptions: Apollo.QueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
      }
export function useGetUserLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserQuery, GetUserQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserQuery, GetUserQueryVariables>(GetUserDocument, options);
        }
export type GetUserQueryHookResult = ReturnType<typeof useGetUserQuery>;
export type GetUserLazyQueryHookResult = ReturnType<typeof useGetUserLazyQuery>;
export type GetUserQueryResult = Apollo.QueryResult<GetUserQuery, GetUserQueryVariables>;
export const GetUserByIdDocument = gql`
    query getUserById($id: String!) {
  user(where: {id: $id}) {
    email
    image
    id
    description
    name
  }
}
    `;

/**
 * __useGetUserByIdQuery__
 *
 * To run a query within a React component, call `useGetUserByIdQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUserByIdQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUserByIdQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetUserByIdQuery(baseOptions: Apollo.QueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
      }
export function useGetUserByIdLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUserByIdQuery, GetUserByIdQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUserByIdQuery, GetUserByIdQueryVariables>(GetUserByIdDocument, options);
        }
export type GetUserByIdQueryHookResult = ReturnType<typeof useGetUserByIdQuery>;
export type GetUserByIdLazyQueryHookResult = ReturnType<typeof useGetUserByIdLazyQuery>;
export type GetUserByIdQueryResult = Apollo.QueryResult<GetUserByIdQuery, GetUserByIdQueryVariables>;
export const GetUsersDocument = gql`
    query getUsers {
  users {
    id
  }
}
    `;

/**
 * __useGetUsersQuery__
 *
 * To run a query within a React component, call `useGetUsersQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetUsersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetUsersQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetUsersQuery(baseOptions?: Apollo.QueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
      }
export function useGetUsersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetUsersQuery, GetUsersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetUsersQuery, GetUsersQueryVariables>(GetUsersDocument, options);
        }
export type GetUsersQueryHookResult = ReturnType<typeof useGetUsersQuery>;
export type GetUsersLazyQueryHookResult = ReturnType<typeof useGetUsersLazyQuery>;
export type GetUsersQueryResult = Apollo.QueryResult<GetUsersQuery, GetUsersQueryVariables>;
export const AddFriendDocument = gql`
    mutation addFriend($email: String!, $friendId: String!) {
  addFriend(where: {email: $email}, friendId: $friendId) {
    friends {
      id
    }
  }
}
    `;
export type AddFriendMutationFn = Apollo.MutationFunction<AddFriendMutation, AddFriendMutationVariables>;

/**
 * __useAddFriendMutation__
 *
 * To run a mutation, you first call `useAddFriendMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddFriendMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addFriendMutation, { data, loading, error }] = useAddFriendMutation({
 *   variables: {
 *      email: // value for 'email'
 *      friendId: // value for 'friendId'
 *   },
 * });
 */
export function useAddFriendMutation(baseOptions?: Apollo.MutationHookOptions<AddFriendMutation, AddFriendMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddFriendMutation, AddFriendMutationVariables>(AddFriendDocument, options);
      }
export type AddFriendMutationHookResult = ReturnType<typeof useAddFriendMutation>;
export type AddFriendMutationResult = Apollo.MutationResult<AddFriendMutation>;
export type AddFriendMutationOptions = Apollo.BaseMutationOptions<AddFriendMutation, AddFriendMutationVariables>;
export const CreateGroupDocument = gql`
    mutation createGroup($name: String!, $end: DateTime!, $friendIds: [UserWhereUniqueInput!]) {
  createOneGroup(
    data: {gameType: WORD_GOLF, name: $name, endAt: $end, users: {connect: $friendIds}}
  ) {
    id
  }
}
    `;
export type CreateGroupMutationFn = Apollo.MutationFunction<CreateGroupMutation, CreateGroupMutationVariables>;

/**
 * __useCreateGroupMutation__
 *
 * To run a mutation, you first call `useCreateGroupMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCreateGroupMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [createGroupMutation, { data, loading, error }] = useCreateGroupMutation({
 *   variables: {
 *      name: // value for 'name'
 *      end: // value for 'end'
 *      friendIds: // value for 'friendIds'
 *   },
 * });
 */
export function useCreateGroupMutation(baseOptions?: Apollo.MutationHookOptions<CreateGroupMutation, CreateGroupMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CreateGroupMutation, CreateGroupMutationVariables>(CreateGroupDocument, options);
      }
export type CreateGroupMutationHookResult = ReturnType<typeof useCreateGroupMutation>;
export type CreateGroupMutationResult = Apollo.MutationResult<CreateGroupMutation>;
export type CreateGroupMutationOptions = Apollo.BaseMutationOptions<CreateGroupMutation, CreateGroupMutationVariables>;
export const GetGroupDocument = gql`
    query getGroup($groupId: String!) {
  group(where: {id: $groupId}) {
    createdAt
    endAt
    users {
      id
    }
  }
}
    `;

/**
 * __useGetGroupQuery__
 *
 * To run a query within a React component, call `useGetGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupQuery({
 *   variables: {
 *      groupId: // value for 'groupId'
 *   },
 * });
 */
export function useGetGroupQuery(baseOptions: Apollo.QueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
      }
export function useGetGroupLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupQuery, GetGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupQuery, GetGroupQueryVariables>(GetGroupDocument, options);
        }
export type GetGroupQueryHookResult = ReturnType<typeof useGetGroupQuery>;
export type GetGroupLazyQueryHookResult = ReturnType<typeof useGetGroupLazyQuery>;
export type GetGroupQueryResult = Apollo.QueryResult<GetGroupQuery, GetGroupQueryVariables>;
export const GetGroupGamesDocument = gql`
    query getGroupGames($startTime: DateTime!, $endTime: DateTime!) {
  games(
    where: {AND: [{gameType: {equals: WORD_GOLF}}, {createdAt: {lt: $endTime}}, {createdAt: {gte: $startTime}}]}
    orderBy: {createdAt: desc}
  ) {
    id
    createdAt
    gameType
    seed
  }
}
    `;

/**
 * __useGetGroupGamesQuery__
 *
 * To run a query within a React component, call `useGetGroupGamesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupGamesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupGamesQuery({
 *   variables: {
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetGroupGamesQuery(baseOptions: Apollo.QueryHookOptions<GetGroupGamesQuery, GetGroupGamesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupGamesQuery, GetGroupGamesQueryVariables>(GetGroupGamesDocument, options);
      }
export function useGetGroupGamesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupGamesQuery, GetGroupGamesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupGamesQuery, GetGroupGamesQueryVariables>(GetGroupGamesDocument, options);
        }
export type GetGroupGamesQueryHookResult = ReturnType<typeof useGetGroupGamesQuery>;
export type GetGroupGamesLazyQueryHookResult = ReturnType<typeof useGetGroupGamesLazyQuery>;
export type GetGroupGamesQueryResult = Apollo.QueryResult<GetGroupGamesQuery, GetGroupGamesQueryVariables>;
export const GetScoresDocument = gql`
    query getScores($userIds: [String!]!, $startTime: DateTime!, $endTime: DateTime!) {
  results(
    where: {AND: [{gameType: {equals: WORD_GOLF}}, {createdAt: {lt: $endTime}}, {createdAt: {gte: $startTime}}, {userId: {in: $userIds}}, {isFinished: {equals: true}}]}
    orderBy: {updatedAt: desc}
  ) {
    id
    user {
      id
      image
      description
      name
    }
    score
    isFinished
    gameId
    updatedAt
  }
  games(
    where: {gameType: {equals: WORD_GOLF}}
    orderBy: {createdAt: desc}
    take: 1
  ) {
    id
  }
}
    `;

/**
 * __useGetScoresQuery__
 *
 * To run a query within a React component, call `useGetScoresQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetScoresQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetScoresQuery({
 *   variables: {
 *      userIds: // value for 'userIds'
 *      startTime: // value for 'startTime'
 *      endTime: // value for 'endTime'
 *   },
 * });
 */
export function useGetScoresQuery(baseOptions: Apollo.QueryHookOptions<GetScoresQuery, GetScoresQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetScoresQuery, GetScoresQueryVariables>(GetScoresDocument, options);
      }
export function useGetScoresLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetScoresQuery, GetScoresQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetScoresQuery, GetScoresQueryVariables>(GetScoresDocument, options);
        }
export type GetScoresQueryHookResult = ReturnType<typeof useGetScoresQuery>;
export type GetScoresLazyQueryHookResult = ReturnType<typeof useGetScoresLazyQuery>;
export type GetScoresQueryResult = Apollo.QueryResult<GetScoresQuery, GetScoresQueryVariables>;
export const GetGroupsDocument = gql`
    query getGroups($email: String!, $now: DateTime!) {
  groups(
    where: {AND: [{users: {some: {email: {equals: $email}}}}, {endAt: {gt: $now}}]}
  ) {
    id
    name
    endAt
    gameType
    users {
      id
      image
    }
  }
}
    `;

/**
 * __useGetGroupsQuery__
 *
 * To run a query within a React component, call `useGetGroupsQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetGroupsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetGroupsQuery({
 *   variables: {
 *      email: // value for 'email'
 *      now: // value for 'now'
 *   },
 * });
 */
export function useGetGroupsQuery(baseOptions: Apollo.QueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
      }
export function useGetGroupsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetGroupsQuery, GetGroupsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetGroupsQuery, GetGroupsQueryVariables>(GetGroupsDocument, options);
        }
export type GetGroupsQueryHookResult = ReturnType<typeof useGetGroupsQuery>;
export type GetGroupsLazyQueryHookResult = ReturnType<typeof useGetGroupsLazyQuery>;
export type GetGroupsQueryResult = Apollo.QueryResult<GetGroupsQuery, GetGroupsQueryVariables>;
export const GetLatestResultDocument = gql`
    query getLatestResult($email: String!, $gameType: GameType!) {
  getResultForGameType(email: $email, gameType: $gameType) {
    id
    createdAt
    score
    isFinished
    userId
    gameId
  }
}
    `;

/**
 * __useGetLatestResultQuery__
 *
 * To run a query within a React component, call `useGetLatestResultQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetLatestResultQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetLatestResultQuery({
 *   variables: {
 *      email: // value for 'email'
 *      gameType: // value for 'gameType'
 *   },
 * });
 */
export function useGetLatestResultQuery(baseOptions: Apollo.QueryHookOptions<GetLatestResultQuery, GetLatestResultQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetLatestResultQuery, GetLatestResultQueryVariables>(GetLatestResultDocument, options);
      }
export function useGetLatestResultLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetLatestResultQuery, GetLatestResultQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetLatestResultQuery, GetLatestResultQueryVariables>(GetLatestResultDocument, options);
        }
export type GetLatestResultQueryHookResult = ReturnType<typeof useGetLatestResultQuery>;
export type GetLatestResultLazyQueryHookResult = ReturnType<typeof useGetLatestResultLazyQuery>;
export type GetLatestResultQueryResult = Apollo.QueryResult<GetLatestResultQuery, GetLatestResultQueryVariables>;